var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1--inject-5",
    cx: 250,
    cy: 337.24,
    rx: 243.5,
    ry: 140.59,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-1--inject-5",
    d: "M269.23,426.21H230.76a1.86,1.86,0,0,1-1.89-2.43l.78-3.1a3.36,3.36,0,0,1,3.11-2.42h34.47a3.35,3.35,0,0,1,3.1,2.42l.79,3.1A1.86,1.86,0,0,1,269.23,426.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-1--inject-5",
    cx: 437.5,
    cy: 391.01,
    rx: 21.96,
    ry: 12.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-1--inject-5",
    cx: 70.95,
    cy: 392.43,
    rx: 21.96,
    ry: 12.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-5",
    d: "M147.9,384.18l-19.22,11.13a2.39,2.39,0,0,1-2.15,0L69.77,362.58a.65.65,0,0,1,0-1.24L89,350.21a2.39,2.39,0,0,1,2.15,0l56.77,32.73A.66.66,0,0,1,147.9,384.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-5",
    d: "M434.55,351.3l-55.79,32.23a2.1,2.1,0,0,1-1.89,0l-46.85-27c-.53-.31-.53-.79,0-1.09l55.79-32.23a2.1,2.1,0,0,1,1.89,0l46.85,27A.58.58,0,0,1,434.55,351.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-5",
    d: "M168.42,375.32l13.12-7.57a.51.51,0,0,0,0-1L109.23,325a1.89,1.89,0,0,0-1.67,0l-13.12,7.58c-.47.26-.47.7,0,1l72.3,41.74A1.84,1.84,0,0,0,168.42,375.32Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--world--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.91,143.1a74.33,74.33,0,1,1-52.3-44.81A74.31,74.31,0,0,1,319.91,143.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,107.29c-3.4.06-7.76,1.26-4.6,3.19s5.17,2.12,5.2,4.62-1.61,5.14-.81,6.92,2.13,3.85,3.43,3.25,4.83-4.55,6.85-4.37,8.9.49,9.9-1.76,2-2.1,3.66-4.6,1.56-5.83-.45-5.85-2.28.85-5.64.6-4.92-2.46-8.19-1.88S244.51,107.25,242,107.29Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,108.18c-3.85,2.06-12,5.17-15.73,4.12-1.87-.53-4.09-1.27-6.46-1.71A74.51,74.51,0,0,0,178.43,154a24.59,24.59,0,0,0,3.36,5.2c2.94,3.45,6,3.89,9.71,4.61s2.56,2.82,4.39,5,2.62,3.48,4.71,4.66-.74,3.39-1.56,5.8-1.06,3.76.66,8.64,6.7,8.86,8.18,10.75-1,4.09-.39,8,.44,14.49,4.24,20.4,6.08,5.23,5.77,1.24-1.59-7.76.71-10.76,7-2.2,8.58-7.68,2.61-5.21,5.15-7.07,1.4-3.46,3.76-7.69,3.05-8.22-.44-10-5.79-1.56-8.79-5.68a38.42,38.42,0,0,0-12-10.45c-4.32-2.34-11.18.52-13.92-.28s-4.48-6-4.3-8-1.86-2.54-3.83-2.05-3.07-.76-3.61-3.4,3.56-6,6.89-6.22,5.11,1.29,5.77,5.58a8.35,8.35,0,0,0,6.57,7.19c3.07.77,1.15-2.42-1-4.6s-2.33-4.17-.69-9,5.68-4.45,8.69-8.87,3.59-1.1,6.63-.66,2.59-1.2,3.71-4,5-.38,8.16-2.63-3.45-5.76-3-8.8,3.46-2.93,1.78-7.49.64-4.73,1.84-6.43S233.23,106.12,229.37,108.18Zm-4.5,11.12c-1,2.25-1.86,1.82-3.51,4.28a9.3,9.3,0,0,1-5.88,4c-1.66.2-4.39-2.75-4.53-4.58s2.49-2.37,5.47-2.75a16.7,16.7,0,0,0,8.24-3.81C226.8,114.8,225.88,117.06,224.87,119.3Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,165.07v.21a5.25,5.25,0,0,0-2.94,2.92c-1.69,4.15-2,2.33-6,5.15s-2.45,5-2.24,7.85-4.38,6-6.65,7-3.28,7.44-2.53,10.57-3,4.4-5.3,7.25-3.6,7.63-5.1,9.92a7,7,0,0,1-6.93,3.21c-2.72-.46-5.24-5-6.7-8.86a22.68,22.68,0,0,1-1.12-12.45c.85-4.24.55-3.71-.46-10.33a10.56,10.56,0,0,0-8.23-9.23c-2.56-.64-6.79.85-9.07-.48s-3.25-3.26-4.74-9.49,1.6-7.65,4-11a23.24,23.24,0,0,1,11.42-8.07,12.57,12.57,0,0,1,9.78,1.26c2.61,1.3,3.84,4.22,5.7,4.42s3.45-.77,5.31-.41,3.11,1.27,4.92,1,.66-2.39.4-3.54-1.9-.86-4.08-.88-2.72-.61-3.49-2.06-2-.17-3.07-.76-.85,2.07-.94,3.1-.89-.79-.89-.79-.9,1.41-1.29.76.51-2.2.38-3.8-2.43-1.22-3.87-2.45a5.5,5.5,0,0,0-5.4-.75c-2,.65-2.32.18-3.19,1.91s-5.14,2.9-6.49,2.67-.4-3,.76-5.4,3.55-1.62,5-4.07-.55-2.8-1.92-3.19-1.8-1.71-.37-4.83,3.33-2.26,4.12-.82a4.81,4.81,0,0,0,4.35,2.18c1.83,0,1.4-1.27,1.36-4s1.19-4.1,3.62-5.12,6.49-2.67,8-4.13,4.31-.5,5.76,1.07,4.68,2.15,8.07,2.72a2.79,2.79,0,0,0,2.4-.79A74,74,0,0,1,325,165.07Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.09,201.65c-1.81-.31-1.65.29-2.71,1.71s-2.61,3-2.33,4.52.42,3.31,1.67,2.22.82-2.41,2.6-3.21S313.8,202.11,311.09,201.65Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,104.85c-47.33-13.67-56.17,18.6-31.08,38.93s68.08,27,73.87,13.63S305.45,115,270.26,104.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.75,208c-36.79-30.18-35.64-88.78-3.4-107.72h0c-1.36.46-2.72.94-4.07,1.48a74.32,74.32,0,1,0,96.17,97.7C309.06,213.83,267.51,238.12,230.75,208Z",
    style: {
      opacity: 0.05,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Contact--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.08,101.12c-2.48-1.44-5.91-1.23-9.69.95-7.56,4.37-13.69,15-13.69,23.72,0,4.38,1.54,7.46,4,8.88l4.82,2.8c2.48,1.43,5.9,1.23,9.68-1,7.57-4.36,13.7-15,13.7-23.72,0-4.36-1.53-7.43-4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.24,104.88c-7.56,4.37-13.69,15-13.69,23.73s6.13,12.27,13.69,7.9,13.71-15,13.7-23.72S425.8,100.52,418.24,104.88Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,124.26v1a21.94,21.94,0,0,1-7.56,7.92c-2.94,1.7-5.61,1.88-7.56.8v-2.06a13.47,13.47,0,0,1,6.16-10.68l2-1.15c1.77-1,3.48-1.15,4.82-.37S425.8,122.16,425.8,124.26Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.08,101.12l4.85,2.81c-2.48-1.44-5.9-1.23-9.69.95-4.95,2.87-9.29,8.41-11.69,14.35l-4.86-2.82c2.41-5.94,6.75-11.48,11.7-14.34C417.17,99.89,420.6,99.68,423.08,101.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,137.36l-4.64-2.69c-2.5-1.42-4-4.5-4-8.88l4.85,2.82C404.55,132.86,406,135.89,408.38,137.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.69,116.41l4.86,2.82a25.36,25.36,0,0,0-2,9.38h0l-4.85-2.82A25.58,25.58,0,0,1,401.69,116.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.52,119.63a2.65,2.65,0,0,1-1.32-.34,3.25,3.25,0,0,1-1.43-3,8.52,8.52,0,0,1,3.92-6.77h0a2.92,2.92,0,0,1,4.71,2.73,8.51,8.51,0,0,1-3.91,6.77A4,4,0,0,1,416.52,119.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.65,119.72c-1.34-.78-3-.64-4.82.37l-2,1.15a13.47,13.47,0,0,0-6.16,10.68V134c1.95,1.08,4.62.9,7.56-.8a21.94,21.94,0,0,0,7.56-7.92v-1C425.8,122.16,425,120.51,423.65,119.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Twitter--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.78,219.16a24.25,24.25,0,0,0,2.13-10.07,18.94,18.94,0,0,0,1.74-3.42,12.61,12.61,0,0,1-2,1.89,9.24,9.24,0,0,0,1.53-3.46,13.21,13.21,0,0,1-2.22,2.41,2.13,2.13,0,0,0-2.54,0,8.26,8.26,0,0,0-3.4,7.68c-2.9,1.48-5.47,1.11-7.19-.71-.92,2.62-.48,5.1,1.08,5.59a2.59,2.59,0,0,1-1.58.33c0,2.17,1.12,3.52,2.79,3a4.32,4.32,0,0,1-1.57,1,2.06,2.06,0,0,0,3.26,1.35,12.1,12.1,0,0,1-5.17,4.91,7,7,0,0,0,5.35-1c3.45-2,6.1-5.59,7.79-9.49",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Instagram--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.54,206.57c2.48-1.43,5.9-1.23,9.69,1,7.56,4.37,13.69,15,13.69,23.73,0,4.38-1.55,7.45-4,8.87l-4.83,2.8c-2.47,1.43-5.9,1.23-9.68-.95-7.56-4.37-13.69-15-13.69-23.73,0-4.36,1.53-7.43,4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.37,210.34c7.56,4.37,13.7,15,13.7,23.72s-6.14,12.27-13.7,7.91-13.7-15-13.69-23.73S83.82,206,91.37,210.34Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,221.64c-1.68-1-3,.06-3,2.3a7.28,7.28,0,0,0,3,5.81c1.68,1,3-.06,3-2.3A7.28,7.28,0,0,0,90.4,221.64Zm0,6.69a4.73,4.73,0,0,1-2-3.78c0-1.45.88-2.12,2-1.49a4.74,4.74,0,0,1,2,3.77C92.38,228.29,91.49,229,90.4,228.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.87,223.28c0,.53-.32.77-.71.54a1.69,1.69,0,0,1-.72-1.36c0-.52.32-.76.72-.53a1.69,1.69,0,0,1,.71,1.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,219.66l-10.55-6.1c-.75-.43-1.35,0-1.35,1v14.07a3.21,3.21,0,0,0,1.35,2.57l3.78,2.19,3.14,1.81,3.63,2.09c.74.43,1.35,0,1.35-1V222.23A3.22,3.22,0,0,0,96.1,219.66Zm0,15.93-10.08-5.82a1.1,1.1,0,0,1-.54-.94V215.29l10.08,5.82a1.07,1.07,0,0,1,.54.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.54,206.57l-4.85,2.81c2.48-1.43,5.9-1.23,9.68,1,4.95,2.86,9.29,8.4,11.7,14.34l4.85-2.82c-2.4-5.93-6.74-11.48-11.69-14.34C92.44,205.34,89,205.14,86.54,206.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,242.82l4.64-2.7c2.49-1.42,4-4.49,4-8.87l-4.85,2.81C105.06,238.32,103.6,241.34,101.24,242.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,221.86l-4.85,2.82a25.4,25.4,0,0,1,2,9.38h0l4.85-2.81A25.41,25.41,0,0,0,107.92,221.86Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Facebook--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.79,34c-2.47-1.44-5.9-1.23-9.68.95-7.57,4.37-13.7,15-13.7,23.72,0,4.39,1.55,7.46,4,8.88l4.83,2.8c2.48,1.43,5.9,1.23,9.68-.95,7.56-4.37,13.7-15,13.7-23.73,0-4.36-1.54-7.43-4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,37.8c-7.56,4.37-13.69,15-13.69,23.72S333.4,73.79,341,69.43s13.7-15,13.7-23.73S348.52,33.43,341,37.8Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.79,34l4.86,2.81c-2.48-1.43-5.91-1.23-9.69,1-4.95,2.86-9.29,8.4-11.7,14.34l-4.85-2.82c2.41-5.93,6.74-11.48,11.7-14.34C339.89,32.8,343.32,32.59,345.79,34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,70.28l-4.65-2.7c-2.49-1.42-4-4.49-4-8.87l4.86,2.81C327.27,65.78,328.73,68.8,331.1,70.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.41,49.32l4.85,2.82a25.58,25.58,0,0,0-2,9.38h0l-4.86-2.81A25.41,25.41,0,0,1,324.41,49.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--facebook--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.78,66.93l3.48-2V53.28l2.43-1.4.26-4-2.69,1.55V47.17c0-.92.14-1.36.81-1.74L345,44.34V40.29l-2.41,1.4a7.07,7.07,0,0,0-3.76,6.61v3.1L337,52.45v3.94l1.81-1Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Like--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.39,270.49c-2.47-1.44-5.9-1.23-9.68.95-7.57,4.37-13.7,15-13.7,23.72,0,4.39,1.55,7.46,4,8.88l4.83,2.8c2.48,1.43,5.9,1.23,9.68-1,7.56-4.36,13.7-15,13.7-23.72,0-4.36-1.54-7.43-4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.56,274.26c-7.56,4.36-13.69,15-13.69,23.72s6.13,12.27,13.69,7.9,13.7-15,13.7-23.72S309.12,269.89,301.56,274.26Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,270.49l4.86,2.81c-2.48-1.43-5.91-1.23-9.69.95-4.95,2.87-9.29,8.41-11.7,14.35L285,285.78c2.41-5.94,6.74-11.48,11.7-14.34C300.49,269.26,303.92,269.05,306.39,270.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,306.73,287.05,304c-2.49-1.42-4-4.49-4-8.88l4.86,2.82C287.87,302.24,289.33,305.26,291.7,306.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,285.78l4.85,2.82a25.54,25.54,0,0,0-2,9.38h0L283,295.16A25.4,25.4,0,0,1,285,285.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.38,289.25s2.22-5.1,2.43-5.84a22.76,22.76,0,0,0,0-3.8c0-.49,2-1.85,2.67-.45a7.41,7.41,0,0,1,.34,4.72l4.92-2.87c1-.61,1.47.25,1.47.92a3.73,3.73,0,0,1-.79,2.12s1-.3,1,1a3.46,3.46,0,0,1-1.19,2.41s.32.25.33,1.17a3.92,3.92,0,0,1-1.38,2.46,3,3,0,0,1,.22,1.16,3.78,3.78,0,0,1-1.8,2.83l-8.14,4.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.71 304.03 297.26 301.96 297.21 289.63 293.66 291.69 293.71 304.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.68,143.91l2.26-.18c3-.24,6.53-1.41,6.53-5.67a10,10,0,0,0-4.52-7.83c-1.95-1.12-3.61-.66-4.25,1a10,10,0,0,0-4.24-5.86c-2.5-1.44-4.52-.27-4.52,2.61,0,4.18,3.53,9.46,6.49,13.16Z",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Play--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.32,267.54c2.48-1.43,5.9-1.23,9.69,1,7.56,4.37,13.69,15,13.69,23.72,0,4.38-1.55,7.45-4,8.88l-4.83,2.8c-2.47,1.43-5.9,1.22-9.68-1-7.56-4.37-13.69-15-13.69-23.72,0-4.37,1.53-7.43,4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.15,271.31c7.57,4.37,13.7,15,13.7,23.72s-6.14,12.28-13.7,7.91-13.7-15-13.69-23.72S186.6,267,194.15,271.31Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.32,267.54l-4.85,2.82c2.48-1.44,5.9-1.23,9.68.95,4.95,2.86,9.29,8.41,11.7,14.34l4.85-2.81C208.3,276.9,204,271.36,199,268.5,195.22,266.31,191.8,266.11,189.32,267.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,303.79l4.64-2.69c2.49-1.43,4-4.5,4-8.88L207.85,295C207.84,299.29,206.38,302.32,204,303.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,282.84l-4.85,2.81a25.4,25.4,0,0,1,2,9.38h0l4.85-2.82A25.4,25.4,0,0,0,210.7,282.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,278.43V291.7c0,1,.39,1.72.88,1.63l9.19-1.77c.48-.1.28-1-.47-2l-8.25-11.12C190.44,277.45,189.84,277.44,189.84,278.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Music--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.34,94.18c2.48-1.44,5.9-1.23,9.69.95,7.56,4.37,13.69,15,13.69,23.72,0,4.39-1.54,7.46-4,8.88l-4.82,2.8c-2.48,1.43-5.9,1.23-9.69-1-7.56-4.36-13.69-15-13.69-23.72,0-4.36,1.53-7.43,4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18,98c7.56,4.37,13.69,15,13.69,23.72s-6.13,12.27-13.7,7.9-13.7-15-13.69-23.72S75.62,93.58,83.18,98Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,94.18,73.49,97c2.48-1.43,5.9-1.23,9.68,1,5,2.86,9.3,8.4,11.7,14.34l4.85-2.82C97.32,103.53,93,98,88,95.13,84.24,93,80.82,92.74,78.34,94.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,130.42l4.64-2.69c2.5-1.42,4-4.49,4-8.88l-4.85,2.82C96.87,125.93,95.41,129,93,130.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.72,109.47l-4.85,2.82a25.4,25.4,0,0,1,2,9.38h0l4.85-2.82A25.4,25.4,0,0,0,99.72,109.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,102.05v13.6a4.7,4.7,0,0,0-.9-.69c-1-.6-1.87.21-1.87,1.8a4.91,4.91,0,0,0,1.87,3.95c1,.6,2.27,0,2.27-1.58V106.66l6,3.52v9.76a5.14,5.14,0,0,0-.9-.69c-1-.6-1.53.39-1.53,2a4.93,4.93,0,0,0,1.87,4c1,.6,1.87-.21,1.87-1.8h0v-16.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.87,212.34c-2.48-1.43-5.91-1.23-9.69,1-7.56,4.37-13.69,15-13.69,23.72,0,4.38,1.54,7.45,4,8.88l4.82,2.8c2.48,1.43,5.9,1.22,9.68-1,7.57-4.37,13.7-15,13.7-23.72,0-4.37-1.53-7.43-4-8.86",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,216.11c-7.56,4.37-13.69,15-13.69,23.72s6.13,12.28,13.69,7.91,13.71-15,13.7-23.72S419.59,211.75,412,216.11Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,212.34l4.85,2.82c-2.48-1.44-5.9-1.23-9.69,1-4.95,2.86-9.29,8.41-11.69,14.34l-4.86-2.81c2.41-5.94,6.75-11.48,11.7-14.34C411,211.11,414.39,210.91,416.87,212.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.17,248.59l-4.64-2.69c-2.5-1.43-4-4.5-4-8.88l4.85,2.82C398.34,244.09,399.8,247.12,402.17,248.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.48,227.64l4.86,2.81a25.4,25.4,0,0,0-2,9.38h0L393.49,237A25.58,25.58,0,0,1,395.48,227.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.19,227.28v17.2c0,.52.36.73.81.47l12.07-7a1.79,1.79,0,0,0,.81-1.4V219.37c0-.51-.36-.72-.81-.47l-12.07,7A1.76,1.76,0,0,0,405.19,227.28Zm12.12,10-10.55,6.1c-.45.25-.81,0-.81-.47V228a1.78,1.78,0,0,1,.81-1.4l10.55-6.09c.45-.26.81-.05.81.46v14.87A1.76,1.76,0,0,1,417.31,237.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.95 243.8 405.95 238.96 409.79 231.59 413.78 235.97 412.92 233.85 414.5 230.94 418.12 233.42 418.12 236.78 405.95 243.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.1,224.94c.48-.28.88.1.88.85a2.34,2.34,0,0,1-.88,1.86c-.49.28-.88-.1-.88-.85A2.3,2.3,0,0,1,415.1,224.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.48,74.73l-2.71-5.09L169,63.36V59.51l-6.67,3.85V67.2l2.87,5a.41.41,0,0,0,.2.17h0Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.48,74.73l-2.71-5.09L169,63.36V59.51l-6.67,3.85V67.2l2.87,5a.41.41,0,0,0,.2.17h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14,29.53a4.44,4.44,0,0,0-2-3.46l-1.63-.94a4.41,4.41,0,0,0-4,0L152.82,46.91a4.4,4.4,0,0,0-2,3.46V69.86a4.41,4.41,0,0,0,2,3.47l1.63.94a4.45,4.45,0,0,0,4,0l8-4.64,2.86,5a.42.42,0,0,0,.77-.07l3-8.73,23-13.29a4.44,4.44,0,0,0,2-3.46Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,69.86a4.41,4.41,0,0,0,2,3.47l1.63.94a4.5,4.5,0,0,0,3.65.16c-.94.35-1.66-.18-1.66-1.32V53.62a4.08,4.08,0,0,1,.59-2l-5.62-3.25a4,4,0,0,0-.59,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.07,29c-.23-.85-1-1.12-1.93-.59l-37.7,21.79A3.91,3.91,0,0,0,157,51.65l-5.62-3.25a4.14,4.14,0,0,1,1.41-1.49l37.69-21.78a4.47,4.47,0,0,1,4,0l1.63.94A4.39,4.39,0,0,1,198.07,29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46,53.93a5.88,5.88,0,0,0-2.67,4.62c0,1.7,1.19,2.39,2.67,1.54a5.9,5.9,0,0,0,2.66-4.62C170.12,53.77,168.93,53.08,167.46,53.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.29,48.24a5.91,5.91,0,0,0-2.67,4.62c0,1.7,1.2,2.39,2.67,1.54A5.91,5.91,0,0,0,180,49.78C180,48.08,178.76,47.39,177.29,48.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.13,42.55a5.88,5.88,0,0,0-2.67,4.62c0,1.7,1.19,2.39,2.67,1.54a5.9,5.9,0,0,0,2.66-4.62C189.79,42.39,188.6,41.7,187.13,42.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.62,141.21l17.31-10a1.46,1.46,0,0,0,.59-1.15V114.5c0-.44-.26-.64-.59-.45l-17.31,10a1.43,1.43,0,0,0-.6,1.14v15.58C352,141.2,352.29,141.4,352.62,141.21Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,140.76v-.31l7.16-11.86-7.06-3.91a.5.5,0,0,1,.05-.13l8.8,3.67c.18.08.42-.06.61-.36l8.79-13.8a.12.12,0,0,1,.05,0l-7.05,12.06,7.15,3.6v.3a1.59,1.59,0,0,1-.18.71l-7.33-4-1,1.78c-.42.7-1,1-1.39.8l-1-.58-7.32,12.44A.55.55,0,0,1,352,140.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156,204.87a11.31,11.31,0,0,1,1.44,1.82,15.57,15.57,0,0,1,1.11,2.09,14.12,14.12,0,0,1,.72,2.1,8.64,8.64,0,0,1,.29,1.86.62.62,0,0,1-.12.42.19.19,0,0,1-.26.06l-2.31-1.34a1.16,1.16,0,0,1-.4-.36,3.71,3.71,0,0,1-.31-.55l-.17-.41a4.28,4.28,0,0,0-.32-.65,4.76,4.76,0,0,0-.54-.71,3,3,0,0,0-.77-.62,3.71,3.71,0,0,0-.65-.3,1.1,1.1,0,0,0-.55-.06.54.54,0,0,0-.39.26,1.28,1.28,0,0,0-.15.7,2.34,2.34,0,0,0,.17.88,3.69,3.69,0,0,0,.57.91,10.19,10.19,0,0,0,1,1.12c.44.42,1,.94,1.63,1.54a16,16,0,0,1,1.69,1.86,10.06,10.06,0,0,1,1.21,2,10.29,10.29,0,0,1,.73,2.3,14.12,14.12,0,0,1,.24,2.7,8.25,8.25,0,0,1-.28,2.26,3.84,3.84,0,0,1-.8,1.49,2.25,2.25,0,0,1-1.24.7,3.38,3.38,0,0,1-1.59-.1v2.23a.8.8,0,0,1-.14.51.23.23,0,0,1-.34.06l-2.31-1.34a.9.9,0,0,1-.34-.44,1.8,1.8,0,0,1-.14-.68v-2.33A10.75,10.75,0,0,1,151.2,223a15.36,15.36,0,0,1-1.17-2.14,13.09,13.09,0,0,1-.75-2.21,10.12,10.12,0,0,1-.28-2.09.68.68,0,0,1,.11-.42.2.2,0,0,1,.26-.06l2.32,1.34a1.42,1.42,0,0,1,.39.33,4.27,4.27,0,0,1,.28.5c0,.11.12.28.21.53a6.24,6.24,0,0,0,.38.8,5.15,5.15,0,0,0,.6.86,3.23,3.23,0,0,0,.89.74,3.36,3.36,0,0,0,1.57.54c.42,0,.63-.31.63-.94a2.05,2.05,0,0,0-.23-.92,6,6,0,0,0-.69-1c-.31-.35-.7-.75-1.18-1.2s-1-1-1.69-1.6a10.9,10.9,0,0,1-2.66-3.85,12.84,12.84,0,0,1-.84-4.8,8.06,8.06,0,0,1,.23-2,4.55,4.55,0,0,1,.67-1.49,2.38,2.38,0,0,1,1.06-.86,2.64,2.64,0,0,1,1.42-.16v-2.32a.83.83,0,0,1,.14-.52.25.25,0,0,1,.34-.06l2.31,1.34a.93.93,0,0,1,.34.45,1.75,1.75,0,0,1,.14.67Z",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pin--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.62,42.81,259.43,41h0c-1.51-1-3.62-1-6,.37-4.63,2.67-8.37,9.45-8.37,15.14v1.29c0,5.69,7.65,11.88,7.65,11.88l3.13,1.77s-1.88-2.14-1.67-2.58c2-4.21,7.63-16.09,7.63-20.73v-1.3a10.19,10.19,0,0,0-.36-2.78l.36.21Zm-9.14,13c-2.31,1.33-4.19.25-4.19-2.42,1.25-.19,4.38-5.53,4.19-7.25,2.31-1.33,4.18-.25,4.18,2.42A9.26,9.26,0,0,1,253.48,55.86Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.62,42.81,259.43,41h0c-1.51-1-3.62-1-6,.37-4.63,2.67-8.37,9.45-8.37,15.14v1.29c0,5.69,7.65,11.88,7.65,11.88l3.13,1.77s-1.88-2.14-1.67-2.58c2-4.21,7.63-16.09,7.63-20.73v-1.3a10.19,10.19,0,0,0-.36-2.78l.36.21Zm-9.14,13c-2.31,1.33-4.19.25-4.19-2.42,1.25-.19,4.38-5.53,4.19-7.25,2.31-1.33,4.18-.25,4.18,2.42A9.26,9.26,0,0,1,253.48,55.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.2,48.76c0-5.69-3.75-8.14-8.37-5.47s-8.38,9.45-8.38,15.14v1.3c0,4.38,5,9.46,7.25,11.57a1.13,1.13,0,0,0,1.78-.33c2-4,7.72-16.2,7.72-20.91Zm-8.37,9c-2.32,1.34-4.19.26-4.19-2.41a9.23,9.23,0,0,1,4.19-7.25c2.31-1.34,4.18-.26,4.18,2.41A9.24,9.24,0,0,1,256.83,57.79Z",
    style: {
      fill: "#B42F53"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-1--inject-5",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.21,107.57a.38.38,0,0,1-.24-.09L349.16,57.19a.37.37,0,1,1,.47-.58l61.82,50.3a.37.37,0,0,1-.24.66Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.16,214.37h0a.38.38,0,0,1-.35-.39l3.61-78.28a.38.38,0,0,1,.39-.36.38.38,0,0,1,.36.39L410.53,214A.37.37,0,0,1,410.16,214.37Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,219.17a.35.35,0,0,1-.33-.2l-40.93-77a.38.38,0,0,1,.16-.5.37.37,0,0,1,.5.15l40.92,77a.36.36,0,0,1-.15.5A.37.37,0,0,1,404.6,219.17Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,122.35a.36.36,0,0,1-.36-.3.38.38,0,0,1,.29-.44L404,115.53a.36.36,0,0,1,.43.29.38.38,0,0,1-.29.44l-30.64,6.08Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.61,116.78a.37.37,0,0,1-.34-.22L337.19,70.42a.37.37,0,0,1,.19-.49.37.37,0,0,1,.49.2L358,116.26a.36.36,0,0,1-.19.49A.4.4,0,0,1,357.61,116.78Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,56.21a.38.38,0,0,1-.37-.31.36.36,0,0,1,.31-.43L331,44.72a.37.37,0,0,1,.42.31.37.37,0,0,1-.3.43L265.44,56.2Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,119.83a.41.41,0,0,1-.2-.06L264.54,63.26a.37.37,0,1,1,.41-.62L353,119.15a.37.37,0,0,1-.21.68Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.46,202.16h0a.38.38,0,0,1-.33-.42l6.75-60a.37.37,0,0,1,.42-.33.36.36,0,0,1,.32.41l-6.75,60A.37.37,0,0,1,352.46,202.16Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.22,287.89a.37.37,0,0,1-.32-.19.37.37,0,0,1,.13-.51l84-48.9a.37.37,0,0,1,.51.13.37.37,0,0,1-.14.51l-84,48.91A.45.45,0,0,1,312.22,287.89Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.83,229.37h-.11l-39.41-11.47a.38.38,0,0,1-.25-.46.37.37,0,0,1,.46-.26l39.41,11.47a.38.38,0,0,1,.26.46A.38.38,0,0,1,397.83,229.37Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,273.67a.39.39,0,0,1-.23-.07.38.38,0,0,1-.07-.52l29.79-40a.37.37,0,0,1,.52-.08.38.38,0,0,1,.08.53l-29.79,40A.38.38,0,0,1,311.25,273.67Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5,269.82a.35.35,0,0,1-.29-.15L162.36,227.6a.37.37,0,1,1,.58-.46l32.86,42.07a.38.38,0,0,1-.3.61Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,228.8a.38.38,0,0,1-.34-.23.37.37,0,0,1,.21-.49L142,213.89a.38.38,0,0,1,.28.7l-35.62,14.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,194.67a.36.36,0,0,1-.36-.28l-10.89-44.67a.37.37,0,0,1,.27-.45.38.38,0,0,1,.45.28l10.89,44.66a.37.37,0,0,1-.27.45Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,211.23a.35.35,0,0,1-.17,0,.37.37,0,0,1-.16-.5l34-67.79a.38.38,0,0,1,.5-.17.39.39,0,0,1,.17.51L96.5,211A.35.35,0,0,1,96.17,211.23Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.37,208.84a.37.37,0,0,1-.37-.34l-7.75-81a.37.37,0,0,1,.34-.41.36.36,0,0,1,.4.34l7.75,81a.37.37,0,0,1-.33.41Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,287a.34.34,0,0,1-.19-.05l-81.83-47.24a.37.37,0,0,1,.37-.65l81.84,47.25a.37.37,0,0,1-.19.69Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.73,126.07a.4.4,0,0,1-.15,0,.38.38,0,0,1-.19-.49l21.79-49.79a.37.37,0,0,1,.49-.19.36.36,0,0,1,.19.49l-21.78,49.79A.38.38,0,0,1,139.73,126.07Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.53,55.74h-.09l-41.35-10.2a.38.38,0,0,1-.28-.45.39.39,0,0,1,.46-.28L243.62,55a.38.38,0,0,1,.28.45A.38.38,0,0,1,243.53,55.74Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,103.54a.36.36,0,0,1-.3-.15.38.38,0,0,1,.08-.53l55.59-40.15a.39.39,0,0,1,.53.08.38.38,0,0,1-.09.53L92.26,103.47A.36.36,0,0,1,92,103.54Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.21,127a.28.28,0,0,1-.15,0L99.18,114.81a.37.37,0,0,1,.31-.67l25.88,12.11a.37.37,0,0,1,.18.5A.38.38,0,0,1,125.21,127Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,131.86a.4.4,0,0,1-.31-.16.37.37,0,0,1,.09-.52l94-67.13a.37.37,0,0,1,.43.61l-94,67.13A.33.33,0,0,1,146.09,131.86Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.44,286.83h0l-77.17-.05a.36.36,0,0,1,0-.72h0l77.17.06a.36.36,0,1,1,0,.71Z",
    style: {
      fill: "#B42F53"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.64,378.61a25.8,25.8,0,0,0-3.29-9.56c-2.68-4.17-6.36-6.78-9.79-7.05s-6.21,2.89-2.53,5.05,10.19,4.39,13.2,12.5Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,378.61a25.8,25.8,0,0,0-3.29-9.56c-2.68-4.17-6.36-6.78-9.79-7.05s-6.21,2.89-2.53,5.05,10.19,4.39,13.2,12.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.63,377.22l0,0a.18.18,0,0,0,.1-.23c-3.63-8.92-10.52-12.65-13.66-13.37a.18.18,0,0,0-.22.14A.19.19,0,0,0,47,364c3.07.7,9.83,4.36,13.4,13.14A.18.18,0,0,0,60.63,377.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,377.32a3,3,0,0,0,1.78,1.35A3.54,3.54,0,0,1,46,379.93c.78,1.34-.5,3.22.34,4.52a2.33,2.33,0,0,0,1.63.95,14.37,14.37,0,0,0,1.61.14,4.77,4.77,0,0,0,.76-.06,3.53,3.53,0,0,1,2.22.24c1.06.6,1.39,1.94,2,3a5,5,0,0,0,3.59,2.24,3.45,3.45,0,0,0,1.85-.12l.1-.06h0l.19-.22s0,0,0,0a7.34,7.34,0,0,0-.13-2.13v-.13c0-.83.06-1.66.08-2.49,0-1.53,0-3.06,0-4.59a7.48,7.48,0,0,0-.31-3c-.46-1-1.62-1.05-2.06-2.06-.18-.41-.27-.84-.44-1.25a3.55,3.55,0,0,0-3-2.11c-2-.11-3.84,1.53-5.86,1.38-.52,0-1-.2-1.54-.29a4.38,4.38,0,0,0-4.45,1.54A2.09,2.09,0,0,0,42.3,377.32Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,387.31h0a.18.18,0,0,0,.13-.22c-2.8-10.48-13.84-12-16.42-11.8a.17.17,0,1,0,0,.34c2.53-.18,13.33,1.3,16.06,11.55A.18.18,0,0,0,60.46,387.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.19,382a.16.16,0,0,0,.09-.05,9.22,9.22,0,0,1,7.52-2.12.16.16,0,0,0,.19-.14.17.17,0,0,0-.14-.2A9.54,9.54,0,0,0,48,381.71a.16.16,0,0,0,0,.24A.17.17,0,0,0,48.19,382Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.64,407.6A31.29,31.29,0,0,1,270,396.07c3.43-5,8-8,12.22-8.21s7.45,3.76,2.88,6.26-12.61,4.94-16.59,14.71Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.64,407.6A31.29,31.29,0,0,1,270,396.07c3.43-5,8-8,12.22-8.21s7.45,3.76,2.88,6.26-12.61,4.94-16.59,14.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,405.94l0,0a.22.22,0,0,1-.11-.29c4.77-10.74,13.32-15,17.18-15.76a.21.21,0,0,1,.26.17.23.23,0,0,1-.17.27c-3.78.74-12.17,4.93-16.87,15.5A.22.22,0,0,1,266.92,405.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,415a9.29,9.29,0,0,0,.26-3.19,19.34,19.34,0,0,1-.47-3.45,3.74,3.74,0,0,1,1.59-2.4,9.67,9.67,0,0,0,2.31-1.59,10.61,10.61,0,0,0,1-2.69,4.13,4.13,0,0,1,2.15-2.22,4.18,4.18,0,0,1,3.09-.09,11.81,11.81,0,0,1,2.51,1.59,4.75,4.75,0,0,0,2.79,1,21.79,21.79,0,0,1,3.33.16c1.87.3,4.14,1.3,4.47,3.38a2.47,2.47,0,0,1-.18,1.52l0,.06c-.75,1.26-2.5,1.27-3.7,1.75-.33.14-.87.31-1,.66s.06.89.17,1.26c.6,2.09.72,4.8-2.18,5.23a9.2,9.2,0,0,1-3.22-.48,3.28,3.28,0,0,0-3.08.56,6.48,6.48,0,0,0-.93,1.72,5.69,5.69,0,0,1-3.14,2.66,10.22,10.22,0,0,1-4.15.48C265.27,420.68,266.24,417,266.77,415Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,418.25h0a.22.22,0,0,1-.14-.27c3.82-12.67,17.35-14.08,20.49-13.75a.22.22,0,0,1,.19.24.2.2,0,0,1-.23.18c-3.07-.32-16.31,1.06-20,13.46A.21.21,0,0,1,266.73,418.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,412.26a.24.24,0,0,1-.11-.06,11.17,11.17,0,0,0-9.08-2.88.21.21,0,0,1,0-.42,11.64,11.64,0,0,1,9.44,3,.22.22,0,0,1,0,.3A.19.19,0,0,1,281.9,412.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.51,408.7a26.76,26.76,0,0,0-4-13.51c-3.37-5.53-7.76-9.21-11.39-8-3.39,1.11-2.57,5.7,2.61,10.65,3.63,3.47,7.32,7.89,9.06,13l3,6.54Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,408.7a26.76,26.76,0,0,0-4-13.51c-3.37-5.53-7.76-9.21-11.39-8-3.39,1.11-2.57,5.7,2.61,10.65,3.63,3.47,7.32,7.89,9.06,13l3,6.54Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.51,408.7a26.76,26.76,0,0,0-4-13.51c-3.37-5.53-7.76-9.21-11.39-8-3.39,1.11-2.57,5.7,2.61,10.65,3.63,3.47,7.32,7.89,9.06,13l3,6.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M231,411a.22.22,0,0,1-.2-.16c-2.31-8.87-8-18.16-13.21-21.61a.22.22,0,0,1-.06-.31.21.21,0,0,1,.3-.06c5.3,3.5,11.06,12.9,13.4,21.87a.22.22,0,0,1-.16.27S231,411,231,411Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69,418.8a13.22,13.22,0,0,1-6,3.13c-3.87.91-5.74-.84-5.74-.84s1.27-3.79,3.42-5a21.91,21.91,0,0,0-6.59,3.3s-2.39.21-3.62-3.37c0,0,1.26-2.3,5.93-3.84a15.6,15.6,0,0,0-7,.86c-.31.14-2-4.48-2.56-6.63s.32-2.19,2-2.77,7.43-1.29,8.56-.44,1.91,4,1.91,4a7.88,7.88,0,0,0,.35-4.23,10.1,10.1,0,0,1,4.58.19c.45.13,1.2,3.3.37,5.94a10.51,10.51,0,0,0,1.94-5.05,7.28,7.28,0,0,1,3.88,5.08C233.56,411.25,234,415.78,231.69,418.8Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,419a.2.2,0,0,1-.2-.11c-3.65-6.34-16-13.1-20.25-13.61a.22.22,0,1,1,.05-.43c4.34.51,16.87,7.38,20.58,13.82a.22.22,0,0,1-.08.3A.17.17,0,0,1,231.7,419Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.81,376.18a25.68,25.68,0,0,1,3.28-9.56c2.68-4.18,6.36-6.78,9.79-7.05s6.21,2.88,2.53,5.05-10.19,4.38-13.19,12.49Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.81,376.18a25.68,25.68,0,0,1,3.28-9.56c2.68-4.18,6.36-6.78,9.79-7.05s6.21,2.88,2.53,5.05-10.19,4.38-13.19,12.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,374.78h0a.18.18,0,0,1-.1-.24c3.62-8.92,10.51-12.64,13.65-13.36a.17.17,0,0,1,.22.13.18.18,0,0,1-.14.22c-3.07.71-9.83,4.37-13.4,13.15A.17.17,0,0,1,446.81,374.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.15,374.89a3.08,3.08,0,0,1-1.79,1.35,3.43,3.43,0,0,0-1.87,1.26c-.77,1.33.5,3.22-.33,4.52a2.45,2.45,0,0,1-1.64,1,14.37,14.37,0,0,1-1.61.14,4.77,4.77,0,0,1-.76-.06,3.46,3.46,0,0,0-2.22.24c-1.06.6-1.39,1.94-2,3a5.09,5.09,0,0,1-3.58,2.25,3.58,3.58,0,0,1-1.86-.12l-.1-.07h0c-.06-.08-.15-.18-.18-.23l0,0a7.69,7.69,0,0,1,.13-2.13v-.13c0-.84-.06-1.66-.08-2.5,0-1.52-.05-3.06,0-4.59a7.52,7.52,0,0,1,.31-3c.47-1,1.62-1.05,2.06-2.06.18-.4.27-.83.44-1.24a3.58,3.58,0,0,1,3-2.12c2-.1,3.84,1.54,5.86,1.39a14.11,14.11,0,0,0,1.55-.3,4.39,4.39,0,0,1,4.45,1.55A2.14,2.14,0,0,1,465.15,374.89Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,384.88h0a.17.17,0,0,1-.12-.21c2.79-10.48,13.83-12,16.41-11.81a.17.17,0,0,1,.16.19.17.17,0,0,1-.18.16c-2.53-.19-13.33,1.3-16.06,11.55A.18.18,0,0,1,447,384.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.25,379.56a.15.15,0,0,1-.09,0,9.16,9.16,0,0,0-7.52-2.12.17.17,0,0,1-.19-.15.16.16,0,0,1,.14-.19,9.51,9.51,0,0,1,7.81,2.21.18.18,0,0,1,0,.25A.17.17,0,0,1,459.25,379.56Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Devices--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.48,353.85a2.89,2.89,0,0,0,1.34,2.23l37.68,21.75a3,3,0,0,0,2.68,0l51.55-29.76a2.53,2.53,0,0,0,0-4.47l-37.67-21.75a3,3,0,0,0-2.69,0l-51.55,29.76A2.89,2.89,0,0,0,333.48,353.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.84,375.24v2.91a2.77,2.77,0,0,1-1.34-.32l-37.68-21.75a2.52,2.52,0,0,1-.13-4.38c-.61.43-.56,1.07.13,1.47l37.68,21.75A2.77,2.77,0,0,0,373.84,375.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.22,351.66a2.86,2.86,0,0,1-1.26-2.28V304.43a3,3,0,0,1,1.34-2.33l51.55-29.76a2.52,2.52,0,0,1,3.86,2.23v44.95a3,3,0,0,1-1.34,2.33l-51.55,29.76A2.87,2.87,0,0,1,332.22,351.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,351.69a2.51,2.51,0,0,1-3.71-2.31v-45a2.78,2.78,0,0,1,.39-1.32l2.52,1.45h0a2.75,2.75,0,0,0-.39,1.32v45C333.48,351.63,334,352,334.67,351.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.48,305.88v45c0,.85.6,1.2,1.34.77l51.55-29.76a3,3,0,0,0,1.34-2.33V274.57c0-.86-.6-1.2-1.34-.78l-51.55,29.76A3,3,0,0,0,333.48,305.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.82,353.17l37.68,21.74a3,3,0,0,0,2.68,0l51.55-29.75a.83.83,0,0,0,0-1.56l-37.67-21.75a3,3,0,0,0-2.69,0l-51.55,29.76A.83.83,0,0,0,334.82,353.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.55,306.05l49.69-28.69c.45-.25.81,0,.81.47v38.91a1.78,1.78,0,0,1-.81,1.4l-49.69,28.69c-.45.25-.81,0-.81-.47V307.45A1.78,1.78,0,0,1,335.55,306.05Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,298.57l-.13-.11h0c-1.9-1.43-4.43-1.36-7.12.19a19.5,19.5,0,0,0-6.89,7.62l-.16.29-.08.15a24.77,24.77,0,0,0-2.95,11.22c0,3.59,1,6.37,2.95,7.81s4.44,1.37,7.13-.18a19.88,19.88,0,0,0,7.14-8.06,24.77,24.77,0,0,0,3-11.22C370.48,302.76,369.48,300,367.66,298.57ZM362,324.19a11.83,11.83,0,0,1-1.11.79l-.47.29-.46.25a10.48,10.48,0,0,1-1.11.49c-4.67,1.69-8.25-1.62-8.3-8.07v-.28a24.55,24.55,0,0,1,3-11l.16-.29a21.1,21.1,0,0,1,5.17-6.38,11.83,11.83,0,0,1,1.11-.79l.46-.29.47-.25a10.48,10.48,0,0,1,1.11-.49,5.53,5.53,0,0,1,5.38.56,1.67,1.67,0,0,1,.16.12c1.69,1.36,2.74,3.92,2.76,7.39v.28C370.22,313.05,366.64,320.49,362,324.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.39,326.16c-2.81,1.62-5.46,1.69-7.45.18s-3.09-4.4-3.09-8.16a26,26,0,0,1,3.09-11.72l.08-.16.17-.31a20.5,20.5,0,0,1,7.2-8c2.81-1.62,5.45-1.69,7.44-.2l0,0,.14.1h0c1.9,1.54,2.95,4.4,2.95,8.06a26,26,0,0,1-3.09,11.72A20.73,20.73,0,0,1,360.39,326.16Zm0-26.63-.44.27c-.35.23-.71.48-1.06.76a20.17,20.17,0,0,0-4.93,6.08l-.15.28A23.37,23.37,0,0,0,351,317.4v.27c0,6.1,3.38,9.34,7.92,7.7a9.81,9.81,0,0,0,1.06-.47c.29-.15.6-.33.89-.51s.71-.49,1.06-.76h0c4.54-3.6,7.87-10.68,7.92-16.84v-.27c0-3.2-1-5.7-2.64-7l-.15-.12a5.26,5.26,0,0,0-5.13-.53,9.81,9.81,0,0,0-1.06.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.83,298.25l-.13-.1,0,0-.16-.12-.16.31-.16.28a25.26,25.26,0,0,1-1.84,2.88,1.88,1.88,0,0,0-.18.24,18.78,18.78,0,0,1-2.92,3l-.21.16a13.87,13.87,0,0,1-1.43,1,9.68,9.68,0,0,1-1.85.83l-.2.06a5.82,5.82,0,0,1-2.85.15l-.18,0a4.88,4.88,0,0,1-1.72-.82l-.14-.11-.16-.14-.17.31c0,.09-.11.19-.16.3l-.17.31.16.13.14.11,0,0a5.37,5.37,0,0,0,1.87.89l.19,0a6.29,6.29,0,0,0,3.05-.19l.21-.06a10.49,10.49,0,0,0,2-.88,15.65,15.65,0,0,0,1.52-1l.22-.17a19.56,19.56,0,0,0,3.12-3.22l.19-.26a23.78,23.78,0,0,0,2-3.12c.06-.09.11-.19.17-.3l.16-.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.83,316.91a.91.91,0,0,1-.16-.11,5.09,5.09,0,0,0-2-.8,1.08,1.08,0,0,0-.19,0,6.51,6.51,0,0,0-3.12.38l-.22.08a10,10,0,0,0-1.52.73,13.55,13.55,0,0,0-1.95,1.37l-.22.18a20.18,20.18,0,0,0-3.05,3.34l-.19.26a27,27,0,0,0-1.87,3.05l0,.05c-.05.08-.09.17-.14.26L353,326l.17.12a1.67,1.67,0,0,0,.16.12l.17.11.16-.32.14-.28a25.38,25.38,0,0,1,1.72-2.81l.18-.25a19.29,19.29,0,0,1,2.85-3.13l.2-.17a12.49,12.49,0,0,1,1.85-1.3,9.81,9.81,0,0,1,1.43-.69l.21-.07a6.15,6.15,0,0,1,2.92-.35l.18,0a4.78,4.78,0,0,1,1.84.75l.16.1.16.12.16-.3,0-.05c0-.08.09-.17.13-.26L368,317Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.22,300.24c-1-2.07-2.37-2.75-3.82-1.91s-2.82,3.09-3.83,6.33a36.39,36.39,0,0,0-1.52,10.52,21.19,21.19,0,0,0,1.52,8.77c1,2.07,2.37,2.75,3.83,1.91s2.81-3.09,3.82-6.33A36.39,36.39,0,0,0,365.74,309,21.19,21.19,0,0,0,364.22,300.24ZM360.4,325c-1.26.73-2.44.09-3.35-1.78a20.24,20.24,0,0,1-1.43-8.32,34.66,34.66,0,0,1,1.43-10c.91-2.92,2.09-4.92,3.35-5.64s2.43-.09,3.34,1.78a20.24,20.24,0,0,1,1.43,8.32,34.66,34.66,0,0,1-1.43,10C362.83,322.23,361.65,324.23,360.4,325Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.38,305.87l-20,11.53a.87.87,0,0,0-.34.68c0,.25.15.4.34.29l20-11.53a.87.87,0,0,0,.34-.68C370.72,305.91,370.57,305.76,370.38,305.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,325.22V298.6c0-.25-.17-.35-.36-.24a.84.84,0,0,0-.37.66v26.62c0,.25.18.36.37.25A.87.87,0,0,0,360.75,325.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2,352,387,324.38a1.46,1.46,0,0,1,1.35,0l2.44,1.41a.41.41,0,0,1,0,.78L343,354.19a1.5,1.5,0,0,1-1.34,0l-2.44-1.41A.41.41,0,0,1,339.2,352Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,355.64,393.35,328a1.44,1.44,0,0,1,1.34,0l15.05,8.69c.37.21.37.56,0,.78L362,365.07a1.47,1.47,0,0,1-1.34,0l-15.11-8.65A.41.41,0,0,1,345.5,355.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39,340.45l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,388.39,340.45Zm-3-3.44-1.49.87c-.07,0-.06.09,0,.13l1.73,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.13l-1.74-1A.25.25,0,0,0,385.43,337Zm-4.83,2.79-2.54,1.47c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l2.54-1.46c.06,0,.05-.1,0-.14l-1.74-1A.27.27,0,0,0,380.6,339.8Zm2.65-1.53-1.5.87c-.07,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.74-1A.27.27,0,0,0,383.25,338.27Zm-5.88,3.4-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,377.37,341.67Zm-2.19,1.26-1.5.87c-.06,0-.06.09,0,.13l1.73,1a.26.26,0,0,0,.24,0l1.5-.87c.06,0,.06-.09,0-.13l-1.73-1A.26.26,0,0,0,375.18,342.93ZM382,347l1.5-.87c.06,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13l1.73,1A.29.29,0,0,0,382,347Zm-2.19,1.26,1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,379.8,348.26Zm-2.19,1.27,1.5-.87c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.74,1A.27.27,0,0,0,377.61,349.53Zm-2.19,1.26,1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.49.87c-.07,0-.06.1,0,.14l1.74,1A.27.27,0,0,0,375.42,350.79Zm10.78-9.08,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,386.2,341.71Zm-2,4,3.34-1.93c.07,0,.06-.09,0-.13l-4.21-2.43a.29.29,0,0,0-.24,0l-1.73,1c-.06,0-.06.1,0,.14l2.23,1.28c.07,0,.07.11,0,.14l-1.39.8c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,384.18,345.73ZM373,344.2l-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,373,344.2Zm-2.19,1.26-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,370.8,345.46Zm-10.94,14.17a.26.26,0,0,0,.24,0l1.5-.87c.06,0,.06-.09,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13Zm-6.57-4.06-1.5.87c-.07,0-.06.1,0,.13l1.73,1a.26.26,0,0,0,.24,0l1.5-.87c.06,0,.06-.09,0-.13l-1.74-1A.24.24,0,0,0,353.29,355.57Zm3.52,3a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm6.92,1.86,1.49-.86c.07,0,.06-.1,0-.14l-1.74-1a.29.29,0,0,0-.24,0l-1.49.87c-.07,0-.06.1,0,.14l1.74,1A.26.26,0,0,0,363.73,360.4Zm-2.43,1.26a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14l-1.74-1a.25.25,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14Zm-5.82-7.35-1.5.86c-.07,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14l-1.74-1A.24.24,0,0,0,355.48,354.31ZM366.42,348l-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.5-.87c.07,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,366.42,348ZM357.66,353l-1.49.87c-.07,0-.06.1,0,.14l1.74,1a.25.25,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.74-1A.29.29,0,0,0,357.66,353Zm10.95-6.32-1.5.87c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,368.61,346.72Zm-4.38,2.53-1.5.87c-.06,0-.06.1,0,.13l1.74,1a.24.24,0,0,0,.23,0l1.5-.87c.07,0,.06-.09,0-.13l-1.73-1A.26.26,0,0,0,364.23,349.25ZM362,350.52l-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.24.24,0,0,0,.23,0l1.5-.86c.07,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,362,350.52Zm-2.19,1.26-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,359.85,351.78Zm11.2,1.54,1.49-.87c.07,0,.06-.1,0-.13l-1.74-1a.25.25,0,0,0-.24,0l-1.49.87c-.07,0-.06.09,0,.13l1.73,1A.26.26,0,0,0,371.05,353.32Zm19.22-19.1-1.49.86c-.07,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.74-1A.25.25,0,0,0,390.27,334.22Zm-2.65,1.53-1.49.86c-.07,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.74-1A.25.25,0,0,0,387.62,335.75Zm4.84-2.8-1.49.87c-.07,0-.06.1,0,.13l1.74,1a.26.26,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.74-1A.29.29,0,0,0,392.46,333Zm-11.33,11.69,1.5-.87c.06,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13l1.73,1A.29.29,0,0,0,381.13,344.64Zm13.76-12.95a.26.26,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14Zm-21.65,20.36,1.49-.86c.07,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1A.25.25,0,0,0,373.24,352.05Zm26.84-15.5,1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.74,1A.24.24,0,0,0,400.08,336.55Zm-4.66-.16,1.5-.87c.06,0,.06-.09,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13l1.73,1A.26.26,0,0,0,395.42,336.39Zm1.95-3.27a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14Zm.46-.26,4.2,2.42a.26.26,0,0,0,.24,0l1.5-.87c.07,0,.06-.09,0-.13l-4.2-2.43a.29.29,0,0,0-.24,0l-1.5.87C397.76,332.75,397.76,332.82,397.83,332.86Zm-5.08,2.78-1.5.87c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,392.75,335.64Zm-16.48,9.52-1.5.86c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,376.27,345.16Zm21.39-7.35a.27.27,0,0,0,.23,0l1.5-.87c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14Zm-19.2,6.08-1.5.87c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,378.46,343.89Zm-16.41,14.48a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm-3.29-3.1-1.5.87c-.07,0-.06.09,0,.13l1.73,1a.26.26,0,0,0,.24,0l1.5-.87c.06,0,.06-.09,0-.13l-1.73-1A.26.26,0,0,0,358.76,355.27Zm5.72,1.84,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.07,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,364.48,357.11Zm2.19-1.26,1.5-.87c.06,0,.06-.1,0-.14l-1.74-1a.24.24,0,0,0-.23,0l-1.5.86c-.07,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,366.67,355.85Zm2.19-1.27,1.49-.86c.07,0,.06-.1,0-.14l-1.74-1a.27.27,0,0,0-.23,0l-1.5.87c-.07,0-.06.1,0,.14l1.73,1A.26.26,0,0,0,368.86,354.58ZM361,354l-1.5.86c-.07,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.74-1A.24.24,0,0,0,361,354Zm2.19-1.27-1.5.87c-.07,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.74-1A.27.27,0,0,0,363.14,352.74Zm8.75-5.05-1.5.86c-.06,0-.06.1,0,.14l1.74,1a.24.24,0,0,0,.23,0l1.5-.86c.07,0,.06-.1,0-.14l-1.73-1A.25.25,0,0,0,371.89,347.69ZM369.7,349l-1.49.87c-.07,0-.06.09,0,.13l1.74,1a.27.27,0,0,0,.23,0l1.5-.87c.07,0,.06-.1,0-.13l-1.73-1A.26.26,0,0,0,369.7,349Zm4.38-2.53-1.5.87c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.5-.86c.07,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,374.08,346.42Zm-8.76,5.06-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14l-1.74-1A.25.25,0,0,0,365.32,351.48Zm2.19-1.27-1.49.87c-.07,0-.06.1,0,.14l1.74,1a.25.25,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-1.73-1A.29.29,0,0,0,367.51,350.21Zm-1.59,8.93,1.49-.87c.07,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1A.29.29,0,0,0,365.92,359.14Zm-12.85-1.3-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.07,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l1.5-.86C353.14,357.94,353.14,357.88,353.07,357.84Zm3.28,1-1.73-1a.25.25,0,0,0-.24,0l-2.31,1.33c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l2.31-1.33C356.42,358.9,356.42,358.84,356.35,358.8Zm-5.94-2.89-1.73-1a.29.29,0,0,0-.24,0L346.59,356c-.06,0,0,.1,0,.13l1.74,1a.24.24,0,0,0,.23,0l1.85-1.06C350.48,356,350.48,356,350.41,355.91Zm1.41-.82a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm7.58,4.81-1.73-1a.25.25,0,0,0-.24,0l-2.88,1.66c-.07,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l2.88-1.66C359.47,360,359.47,359.94,359.4,359.9Zm1.44,2-1.74-1a.27.27,0,0,0-.23,0L357,362c-.06,0-.06.1,0,.13l1.73,1a.26.26,0,0,0,.24,0l1.85-1.06C360.91,362,360.9,362,360.84,361.93Zm7.26-16.24a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm-4.38,2.53a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14ZM354,353.83a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm11.9-6.87a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm-4.38,2.53a.29.29,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm.51,12.6a.29.29,0,0,0-.24,0l-2.3,1.34c-.07,0-.06.09,0,.13l1.74,1a.26.26,0,0,0,.24,0l2.3-1.33c.06,0,.06-.1,0-.14Zm-3.65-10.79a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm-2.19,1.26a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13Zm46.4-13.89a.25.25,0,0,0-.24,0l-3.69,2.13c-.06,0-.06.09,0,.13l1.74,1a.24.24,0,0,0,.23,0l3.69-2.13c.07,0,.06-.1,0-.14Zm-4.84,2.8a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13l1.74,1a.24.24,0,0,0,.23,0l1.5-.87c.07,0,.06-.09,0-.13Zm-29.66,16.4,1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1A.24.24,0,0,0,368.1,357.87ZM393.38,344a.26.26,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14Zm11.41-6.58a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14Zm3.92-.27-4.2-2.43a.29.29,0,0,0-.24,0l-1.5.86c-.07,0-.06.1,0,.14l4.2,2.43a.29.29,0,0,0,.24,0l1.5-.87C408.78,337.24,408.78,337.18,408.71,337.14ZM385.2,348.72a.29.29,0,0,0-.24,0l-1.84,1.07c-.06,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l1.84-1.06c.07,0,.06-.1,0-.14Zm5.53-3.2a.26.26,0,0,0-.24,0l-2.3,1.33c-.06,0-.06.1,0,.14l1.73,1a.26.26,0,0,0,.24,0l2.3-1.33c.07,0,.06-.1,0-.14Zm-10.6,6.12a.29.29,0,0,0-.24,0l-12.33,7.12c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l12.33-7.12c.07,0,.06-.1,0-.14Zm-13,7.52a.25.25,0,0,0-.24,0L365,360.22c-.07,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.84-1.06c.06,0,.06-.1,0-.14Zm15.56-9a.25.25,0,0,0-.24,0l-1.85,1.06c-.06,0-.06.1,0,.14l1.73,1a.25.25,0,0,0,.24,0l1.85-1.06c.06,0,.06-.1,0-.14Zm-18.09,10.45a.26.26,0,0,0-.24,0l-1.85,1.07c-.06,0-.06.09,0,.13l1.73,1a.26.26,0,0,0,.24,0l1.85-1.07c.06,0,.06-.09,0-.13Zm23.16-13.38a.25.25,0,0,0-.24,0l-1.85,1.06c-.06,0-.06.1,0,.14l1.73,1a.29.29,0,0,0,.24,0l1.85-1.07c.06,0,.06-.1,0-.14Zm7.83-4.52a.25.25,0,0,0-.24,0l-1.49.86c-.07,0-.06.1,0,.14l1.74,1a.24.24,0,0,0,.23,0l1.5-.86c.07,0,.06-.1,0-.14Zm4.8-3.48,1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,400.37,339.25Zm-9.79-.07,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,390.58,339.18Zm-5,8.58,4.38-2.53c.06,0,.06-.09,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-4.38,2.53c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,385.62,347.76Zm12.32-7.25a.29.29,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm-2.23-1.43,1.49-.86c.07,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.49.87c-.07,0-.06.1,0,.14l1.74,1A.25.25,0,0,0,395.71,339.08ZM383.43,349l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,383.43,349Zm9.67-5.73a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm-20.62,12.05,1.5-.87c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,372.48,355.35Zm2.19-1.27,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,374.67,354.08Zm-4.38,2.53,1.5-.87c.07,0,.06-.09,0-.13l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.13l1.74,1A.27.27,0,0,0,370.29,356.61Zm8.76-5.06,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,379.05,351.55Zm-2.19,1.27,1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14l1.73,1A.29.29,0,0,0,376.86,352.82Zm4.38-2.53,1.5-.87c.06,0,.06-.09,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.13l1.73,1A.26.26,0,0,0,381.24,350.29Zm10-18.7a.29.29,0,0,0,.24,0l1.49-.87c.07,0,.06-.1,0-.14l-.47-.26a.24.24,0,0,0-.23,0l-1.5.87c-.07,0-.06.09,0,.13Zm-10.77,7a.24.24,0,0,0,.23,0l1.5-.87c.07,0,.06-.1,0-.13l-1.73-1a.26.26,0,0,0-.24,0l-1.5.87c-.06,0-.06.09,0,.13Zm4.37-2.52a.29.29,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm-7.05,4.07a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm4.86-2.81a.25.25,0,0,0,.24,0l1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.26.26,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm-9.24,5.33a.26.26,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.13Zm2.19-1.26a.29.29,0,0,0,.24,0l1.5-.87c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm11.26-7.23a.25.25,0,0,0,.24,0l1.5-.86c.06,0,.06-.1,0-.14l-.46-.27a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Zm6.57-3.79a.26.26,0,0,0,.24,0l1.49-.86c.07,0,.06-.1,0-.14l-.47-.27a.24.24,0,0,0-.23,0l-1.5.86c-.07,0-.06.1,0,.14Zm3.64,2.1a.24.24,0,0,0,.23,0l1.5-.86c.07,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14Zm5.47,5.55,1.5-.86c.06,0,.06-.1,0-.14l-1.73-1a.29.29,0,0,0-.24,0l-1.5.87c-.06,0-.06.1,0,.14l1.73,1A.25.25,0,0,0,402.56,338Zm-13.49-5.13a.26.26,0,0,0,.24,0l1.5-.87c.06,0,.05-.09,0-.13l-.46-.27a.25.25,0,0,0-.24,0l-1.5.86c-.07,0-.06.1,0,.14Zm-17.83,11a.25.25,0,0,0,.24,0L373,343c.06,0,.06-.1,0-.14l-1.73-1a.25.25,0,0,0-.24,0l-1.5.86c-.06,0-.06.1,0,.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,357l14.79-8.53a1.76,1.76,0,0,1,1.61,0l8.48,4.89a.49.49,0,0,1,0,.93L391,362.85a1.82,1.82,0,0,1-1.61,0L381,358A.49.49,0,0,1,381,357Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.8,
    y: 350.29,
    width: 38.4,
    height: 71.97,
    rx: 2.88,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.89,
    y: 354.72,
    width: 36.21,
    height: 63.11,
    rx: 1.89,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,377l-.15-.16,0,0a11.65,11.65,0,0,0-16.18-.24l-.18.17-.09.09a11.65,11.65,0,1,0,16.63.16Zm-6.57,19.34a10.89,10.89,0,0,1-1.28.14h-1.08a10.89,10.89,0,0,1-1.28-.14,11.42,11.42,0,0,1-9.59-11.14v-.24a11.43,11.43,0,0,1,3.44-8l.18-.17a11.37,11.37,0,0,1,6-2.94,10.88,10.88,0,0,1,1.28-.13h1.08a10.88,10.88,0,0,1,1.28.13,11.38,11.38,0,0,1,6.21,3.17l.18.18a11.43,11.43,0,0,1,3.2,7.79v.24A11.42,11.42,0,0,1,251.82,396.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,397.21a12.18,12.18,0,0,1-8.61-20.79l.1-.09.19-.19a12.17,12.17,0,0,1,16.9.25l0,0,.16.16h0A12.18,12.18,0,0,1,250,397.21Zm0-23.06-.51,0a10.24,10.24,0,0,0-1.23.12,10.86,10.86,0,0,0-5.69,2.8l-.17.17a10.79,10.79,0,0,0-3.28,7.66v.23a10.85,10.85,0,0,0,9.14,10.62,10.26,10.26,0,0,0,1.23.13,8.68,8.68,0,0,0,1,0,10.26,10.26,0,0,0,1.23-.13h0a10.85,10.85,0,0,0,9.14-10.62v-.24a10.8,10.8,0,0,0-3.05-7.42l-.17-.17a10.73,10.73,0,0,0-5.92-3,10.24,10.24,0,0,0-1.23-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.59,376.76l-.16-.16,0,0-.19-.19-.18.19-.18.17a11.21,11.21,0,0,1-2.13,1.56l-.21.12a11,11,0,0,1-3.37,1.16l-.24,0a11.38,11.38,0,0,1-1.66.13,10.73,10.73,0,0,1-2.12-.21l-.24-.05a11,11,0,0,1-3.29-1.29l-.2-.12a11.66,11.66,0,0,1-2-1.57l-.17-.18-.18-.19-.2.18-.18.18-.2.19.19.19.16.16,0,0a11.77,11.77,0,0,0,2.16,1.71l.22.13a11.56,11.56,0,0,0,3.52,1.37l.25.05a12.08,12.08,0,0,0,2.25.21,11.53,11.53,0,0,0,1.77-.13l.24,0a11.52,11.52,0,0,0,3.61-1.23l.22-.12a12,12,0,0,0,2.31-1.7l.19-.18.19-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,392.92l-.18-.17a12.39,12.39,0,0,0-2.32-1.71l-.22-.12a11.81,11.81,0,0,0-3.6-1.23l-.25,0a12.94,12.94,0,0,0-1.77-.13,12.17,12.17,0,0,0-2.25.22l-.25.05a11.8,11.8,0,0,0-3.52,1.36l-.22.13a12.22,12.22,0,0,0-2.16,1.71l0,0-.15.15-.19.2.2.19.18.17.2.19.18-.2.17-.17a10.75,10.75,0,0,1,2-1.57l.2-.13a11.22,11.22,0,0,1,3.29-1.29l.24-.05a11.54,11.54,0,0,1,2.12-.2,11.38,11.38,0,0,1,1.66.12l.24,0a11,11,0,0,1,3.37,1.17l.21.11a11.26,11.26,0,0,1,2.13,1.57l.18.17.18.18.19-.18,0,0,.16-.16.18-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.41,376.68c-1.16-2.3-2.73-3.57-4.41-3.57s-3.25,1.27-4.41,3.57a20.71,20.71,0,0,0,0,16.71c1.16,2.3,2.73,3.56,4.41,3.56s3.25-1.26,4.41-3.56a20.71,20.71,0,0,0,0-16.71ZM250,396.17c-1.45,0-2.82-1.14-3.86-3.21a19.86,19.86,0,0,1,0-15.85c1-2.07,2.41-3.21,3.86-3.21s2.82,1.14,3.86,3.21a19.86,19.86,0,0,1,0,15.85C252.82,395,251.45,396.17,250,396.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,384.63H238.47a.43.43,0,0,0,0,.85h23.06a.43.43,0,0,0,0-.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,396.58V373.52a.42.42,0,0,0-.42-.39.42.42,0,0,0-.42.39v23.06a.42.42,0,0,0,.42.39A.41.41,0,0,0,250.41,396.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.53,351.44h5.64a.6.6,0,0,1,.61.57.59.59,0,0,1-.61.57h-5.64a.59.59,0,0,1-.61-.57A.6.6,0,0,1,247.53,351.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,351.44a.56.56,0,0,1,.57.57.57.57,0,0,1-.57.57.58.58,0,0,1-.57-.57A.57.57,0,0,1,257.2,351.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.49,
    cy: 352.01,
    r: 0.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.21,
    cy: 352.01,
    r: 0.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5,351.44a.57.57,0,0,1,.57.57.58.58,0,0,1-.57.57.57.57,0,0,1-.57-.57A.56.56,0,0,1,243.5,351.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.11,363.14,116,356.72a2.9,2.9,0,0,1-1.71-2.39c0-.86,0-1.54,0-1.54l11.52-6.5a2.44,2.44,0,0,0,1.11-1.91V330.69l19.39,11.2v13.69a2.44,2.44,0,0,1-1.1,1.92l-9.8,5.64A9.11,9.11,0,0,1,127.11,363.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,358v1.54l3.55-2.05a2.45,2.45,0,0,0,1.11-1.92V341.89l-3.7-2.13c-.08.94-.16,1.91-.24,2.86l2.6,1.49v10.7a2.43,2.43,0,0,1-1.11,1.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,354.81a2.46,2.46,0,0,1-1.11,1.92l-8.46,4.87a9.17,9.17,0,0,1-8.29,0L116,355.18c-2.29-1.32-2.29-3.46,0-4.78l8.47-4.88a2.43,2.43,0,0,0,1.1-1.91v-10.7L145,344.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,346.82h0l2.26-1.3a2.43,2.43,0,0,0,1.1-1.91v-10.7L145,344.12v10.69a2.46,2.46,0,0,1-1.11,1.92L141.65,358Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,352.79v1.54a2.93,2.93,0,0,0,1.71,2.4l11.11,6.41a8.2,8.2,0,0,0,4,1v-1.53a8.2,8.2,0,0,1-4-1L116,355.18A2.9,2.9,0,0,1,114.29,352.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,262v59.52a3.09,3.09,0,0,0,1.38,2.4l75.89,43.73.13.06,0,0c.68.3,1.21-.07,1.21-.88V368a2.57,2.57,0,0,0,1.3-.29,3,3,0,0,0,1.29-2.35V305.85a3.06,3.06,0,0,0-1.38-2.39L99.61,259.73a3,3,0,0,0-2.68-.05,2.93,2.93,0,0,0-1.28,2.1A1.94,1.94,0,0,0,95.63,262Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,262v59.52a3.09,3.09,0,0,0,1.38,2.4l75.89,43.73.13.06,0,0c.68.3,1.21-.07,1.21-.88V307.35a3.07,3.07,0,0,0-1.38-2.4L97,261.22c-.69-.4-1.26-.14-1.36.56A1.94,1.94,0,0,0,95.63,262Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,366.87v-4.05l2.59-1.5v4.05a3,3,0,0,1-1.29,2.35,2.57,2.57,0,0,1-1.3.29,1.62,1.62,0,0,1-.31,0l-.31,0h0l-.24-.06h0l-.08,0-.23-.1C173.75,368.05,174.28,367.68,174.28,366.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,317.48v4.06a3.09,3.09,0,0,0,1.38,2.4l75.89,43.73.13.06,0,0c.68.3,1.21-.07,1.21-.88v-4.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.88,306a2.8,2.8,0,0,1,.4,1.36v55.48l2.6-1.5V305.85a2.8,2.8,0,0,0-.4-1.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,355.89V308.21a1.83,1.83,0,0,0-.83-1.44L99.05,265.39c-.45-.26-.82-.05-.82.48v47.68a1.83,1.83,0,0,0,.83,1.44l71.81,41.37C171.32,356.63,171.69,356.41,171.69,355.89Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.15,303.49a31.52,31.52,0,0,0,3.75,14.24c2.42,4.62,5.64,8.25,9.06,10.22s6.63,2.06,9,.23,3.75-5.35,3.75-9.91A31.52,31.52,0,0,0,144,304c0-.06-.07-.12-.1-.19l-.2-.37A24.85,24.85,0,0,0,135,293.8c-3.41-2-6.62-2.05-9-.24l0,0-.17.13C123.42,295.57,122.15,299,122.15,303.49Zm.27.33v-.36c0-4.41,1.37-7.66,3.51-9.38a1.3,1.3,0,0,1,.2-.15,7,7,0,0,1,6.83-.71,12.14,12.14,0,0,1,1.41.62l.59.32.59.36a16.61,16.61,0,0,1,1.41,1,26.8,26.8,0,0,1,6.56,8.09l.2.37a31.09,31.09,0,0,1,3.77,13.95v.36c-.06,8.19-4.61,12.39-10.53,10.24a12.14,12.14,0,0,1-1.41-.62l-.59-.32-.59-.36c-.48-.31-1-.65-1.41-1C127,321.54,122.49,312.09,122.42,303.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.49,318a32.88,32.88,0,0,1-3.92-14.88c0-4.64,1.33-8.27,3.75-10.22h0l.17-.14,0,0c2.53-1.89,5.88-1.79,9.44.26,3.41,2,6.66,5.56,9.15,10.11l.21.38.1.2a32.92,32.92,0,0,1,3.92,14.89c0,4.77-1.39,8.44-3.92,10.35s-5.89,1.83-9.46-.23S128,322.87,125.49,318Zm8.9-23.4a11.91,11.91,0,0,0-1.34-.59,6.65,6.65,0,0,0-6.52.67l-.18.14c-2.13,1.72-3.32,4.9-3.35,8.95v.35c.06,7.82,4.29,16.8,10.05,21.37h0a15.13,15.13,0,0,0,1.35,1,11.59,11.59,0,0,0,1.12.65,11.29,11.29,0,0,0,1.35.59c5.76,2.09,10-2,10-9.76a1.09,1.09,0,0,0,0-.18,1,1,0,0,0,0-.17,29.49,29.49,0,0,0-3.6-13.3,3.9,3.9,0,0,0-.19-.35,25.42,25.42,0,0,0-6.25-7.72q-.68-.53-1.35-1l-.56-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,293.31l.17-.13,0,0,.21-.14.21.38c.06.13.13.25.19.36a30.36,30.36,0,0,0,2.34,3.65l.23.31a22.66,22.66,0,0,0,3.71,3.84l.26.21a15.73,15.73,0,0,0,1.82,1.23A11.72,11.72,0,0,0,137,304l.26.08a7.34,7.34,0,0,0,3.61.19l.23-.05a6.18,6.18,0,0,0,2.18-1l.19-.15.2-.16.22.39.2.38.21.39-.2.17-.18.14h0a6.52,6.52,0,0,1-2.38,1.13,2.1,2.1,0,0,1-.24.06,7.94,7.94,0,0,1-3.87-.23l-.27-.09a12.86,12.86,0,0,1-2.48-1.12,17.28,17.28,0,0,1-1.94-1.3l-.27-.22a24.14,24.14,0,0,1-4-4.09l-.25-.32a32.71,32.71,0,0,1-2.54-4c-.07-.12-.13-.25-.2-.38l-.21-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53,317l.2-.14a6.41,6.41,0,0,1,2.54-1l.25,0a8.44,8.44,0,0,1,4,.49l.27.1a12.67,12.67,0,0,1,1.94.93,16.86,16.86,0,0,1,2.47,1.74,2.6,2.6,0,0,1,.28.23,25.62,25.62,0,0,1,3.87,4.23l.24.34a35,35,0,0,1,2.38,3.87l0,0,.18.34.2.4-.21.15-.2.14-.22.15-.2-.41c-.06-.1-.12-.22-.19-.36a31.6,31.6,0,0,0-2.18-3.56l-.23-.31a23.76,23.76,0,0,0-3.62-4l-.25-.22a17,17,0,0,0-2.34-1.65,12.11,12.11,0,0,0-1.83-.87l-.25-.1a8,8,0,0,0-3.71-.43l-.23,0a6.2,6.2,0,0,0-2.34.94l-.19.14-.21.15-.21-.39,0-.06-.17-.33-.2-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.17,307a46.38,46.38,0,0,0,1.93,13.36c1.29,4.11,3,7,4.86,8s3.57.21,4.85-2.43,1.93-6.51,1.93-11.12a46,46,0,0,0-1.93-13.36c-1.28-4.11-3-7-4.85-8s-3.57-.21-4.86,2.42S128.17,302.35,128.17,307ZM130.72,320a44,44,0,0,1-1.82-12.66c0-4.38.65-8.14,1.82-10.56s2.65-3.18,4.24-2.26,3.09,3.46,4.24,7.16A44,44,0,0,1,141,314.38c0,4.38-.64,8.13-1.81,10.56s-2.65,3.18-4.24,2.26S131.86,323.74,130.72,320Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,303l25.34,14.63a1.12,1.12,0,0,1,.43.87c0,.31-.19.5-.43.37l-25.34-14.64a1.11,1.11,0,0,1-.44-.86C121.85,303,122.05,302.84,122.29,303Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5,327.54V293.75c0-.32.23-.45.47-.31a1.13,1.13,0,0,1,.46.84v33.8c0,.31-.23.44-.46.31A1.11,1.11,0,0,1,134.5,327.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.42,359.54a.73.73,0,0,1,.44-.62l17.82-10.28a2.33,2.33,0,0,1,2.12,0l54.37,31.44a.73.73,0,0,1,.44.61v1.87a.73.73,0,0,1-.44.62l-17.81,10.28a2.33,2.33,0,0,1-2.12,0L71.86,362.07a.73.73,0,0,1-.44-.61C71.41,361.23,71.42,359.76,71.42,359.54Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,359.54a.73.73,0,0,1,.44-.62l17.82-10.28a2.33,2.33,0,0,1,2.12,0l54.37,31.44a.73.73,0,0,1,.44.61v1.87a.73.73,0,0,1-.44.62l-17.81,10.28a2.33,2.33,0,0,1-2.12,0L71.86,362.07a.73.73,0,0,1-.44-.61C71.41,361.23,71.42,359.76,71.42,359.54Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.36,391.55l17.81-10.24a.65.65,0,0,0,0-1.23L91.8,348.64a2.33,2.33,0,0,0-2.12,0L71.86,358.92a.65.65,0,0,0,0,1.23l54.38,31.39A2.36,2.36,0,0,0,128.36,391.55Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.36,391.55l17.81-10.24a.65.65,0,0,0,0-1.23L91.8,348.64a2.33,2.33,0,0,0-2.12,0L71.86,358.92a.65.65,0,0,0,0,1.23l54.38,31.39A2.36,2.36,0,0,0,128.36,391.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.37,391.8v1.91a2.18,2.18,0,0,0,1-.25l17.8-10.28a.73.73,0,0,0,.44-.61v-1.88a.76.76,0,0,1-.44.62l-17.8,10.24A2.18,2.18,0,0,1,127.37,391.8Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.37,391.8v1.91a2.18,2.18,0,0,0,1-.25l17.8-10.28a.73.73,0,0,0,.44-.61v-1.88a.76.76,0,0,1-.44.62l-17.8,10.24A2.18,2.18,0,0,1,127.37,391.8Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,372.76l-2,1.17s-.06.06-.06.07l1.81,1.09,2.13-1.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.85,374.17l-2,1.18a.07.07,0,0,0,0,.07v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,370.38l-2,1.18s-.05,0-.05.07l3,1.75,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85,369l-2,1.18a.08.08,0,0,0,0,.07l1.8,1.08L118.7,370Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.89,362.53l1.8,1.08,2.13-1.26L87,361.28l-2,1.18A.09.09,0,0,0,84.89,362.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.41,367.56l-2,1.17s-.06.06-.06.08l1.81,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49,375.42l-1.84-1.07-2,1.18s0,0,0,.07l1.81,1.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,371.48l1.81,1.08,2.12-1.26L108,370.23l-2,1.18S105.9,371.45,105.9,371.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,377l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.08.08,0,0,0,121,377Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,370.07l1.8,1.08,2.13-1.26-1.85-1.07-2,1.17S103.46,370.05,103.46,370.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,368.66l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.08.08,0,0,0,101,368.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.79,374.3l3.86,2.27,4.89-2.86-2.11-1.21L114.85,374a.34.34,0,0,1-.18,0,.29.29,0,0,1-.17,0l-1.63-.94-2,1.17S110.79,374.28,110.79,374.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.52,364.74l-2,1.18s0,0,0,.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.35,372.89l1.8,1.08,2.13-1.26-1.85-1.07-2,1.17C108.35,372.84,108.35,372.87,108.35,372.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,356.82l1.8,1.08L90,356.64l-1.85-1.07-2,1.17A.09.09,0,0,0,86,356.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,353.46l-2,1.18a.08.08,0,0,0,0,.07v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,358.78v.05l1.79,1,2.13-1.27L86,357.54l-2,1.18A.08.08,0,0,0,83.92,358.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,359.71l1.81,1.08,2.12-1.26-1.85-1.07-2,1.17A.11.11,0,0,0,80,359.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.42,354.87l-2,1.18s0,0,0,.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.44,361.12l1.81,1.08,2.12-1.26-1.84-1.07-2,1.18A.1.1,0,0,0,82.44,361.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75,359.1l-2,1.18s0,0,0,.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2,360.51l-2,1.17a.1.1,0,0,0,0,.08l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,361.92l-2,1.17s-.06.06-.06.08l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.31,357.69l-2,1.17a.08.08,0,0,0,0,.08L97,360l2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,363.33l-2,1.18a.09.09,0,0,0,0,.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.87,356.28l-2,1.18s0,0,0,.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,366.15l-2,1.18a.1.1,0,0,0,0,.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,369.68l-2,1.17a.09.09,0,0,0-.06.07V371l1.8,1,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,377.29l-2,1.17c-.05,0-.05.06-.05.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.69,378.7l-2,1.17a.1.1,0,0,0,0,.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1,368.27l-2,1.17a.11.11,0,0,0,0,.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,380.11l-2,1.17c-.05,0-.06.06-.06.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,372.33v.05l1.79,1,2.13-1.26L115,371.09l-2,1.17S112.91,372.32,112.91,372.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,378.88l-2,1.17c-.06,0-.06.06-.06.08l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,381.7l-2,1.17s-.06.06-.06.08L133.1,384l2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,381.54l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18S128.85,381.51,128.85,381.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,385.88a.13.13,0,0,0,0,.07V386l1.8,1,4.89-2.85-1.85-1.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66,366.86l-2,1.17a.09.09,0,0,0,0,.07v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,383.13v0l1.79,1L130,383l-1.85-1.07-2,1.18A.08.08,0,0,0,126.09,383.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,384.54l1.81,1.08,2.12-1.26-1.85-1.07-2,1.17C128.54,384.49,128.53,384.52,128.53,384.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.45,359.8l-2,1.17s-.06.06-.06.08l1.81,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56,357l-2,1.17c-.05,0-.06.06-.06.08v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,361.61l1.81,1.08,2.12-1.26-1.84-1.07-2,1.18A.08.08,0,0,0,88.8,361.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.36,360.19l1.81,1.09L90.29,360,88.45,359l-2,1.18A.07.07,0,0,0,86.36,360.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,363v0l1.79,1,2.13-1.26-1.85-1.07-2,1.17C91.25,363,91.25,363,91.25,363Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.22,365.44l-2,1.18s0,0,0,.07v.05l1.8,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13,365.84l1.81,1.08,2.12-1.26-1.84-1.07-2,1.17S96.13,365.82,96.13,365.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.69,364.43l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18S93.69,364.4,93.69,364.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33,362.62l-2,1.18s-.06.05-.06.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,358.39l-2,1.17s-.06.06-.06.08l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,364l-2,1.18a.09.09,0,0,0-.06.07l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.89,361.21l-2,1.17a.1.1,0,0,0,0,.08v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,367.25l1.81,1.08,2.13-1.26L100.66,366l-2,1.17A.1.1,0,0,0,98.57,367.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.29,375.58l-2,1.18s-.05,0-.05.07l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,353.12l-1.85-1.07-2,1.18a.08.08,0,0,0,0,.07v0l1.8,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.53,355.23l-2.75-1.59-2,1.18s0,0,0,.07v0l2.7,1.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.12,351.4l-2.23-1.29-2,1.18a.07.07,0,0,0,0,.07l2.19,1.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49,358.12l-2.23-1.29-2,1.17s-.06.06-.06.08l2.19,1.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.41,357.19,82,355.24l-2,1.17a.1.1,0,0,0,0,.07v0l3.34,1.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,353.61l1.8,1.08,2.13-1.26-1.85-1.07-2,1.17A.08.08,0,0,0,92.7,353.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.49,358.43l-2,1.17s-.06,0-.06.07l2.71,1.6L79.24,360Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.14,355l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.1.1,0,0,0,95.14,355Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,361.27v.05l1.8,1,2.12-1.26L108.06,360l-2,1.17A.1.1,0,0,0,106,361.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,362.68l1.8,1.08,2.13-1.26-1.85-1.06-2,1.17S108.42,362.67,108.42,362.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.53,359.86v.05l1.8,1,2.12-1.26-1.85-1.06-2,1.17A.09.09,0,0,0,103.53,359.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,357.84v0l1.8,1,2.13-1.26-1.85-1.07-2,1.18A.07.07,0,0,0,100,357.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,356.43l1.81,1.08,2.12-1.26-1.84-1.07-2,1.18S97.58,356.4,97.58,356.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.09,386.48l-2,1.18a.09.09,0,0,0,0,.07v0l1.79,1,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,379.13l-2,1.17s-.06.06-.06.08l1.8,1.08,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21,383.66l-2,1.17a.11.11,0,0,0-.06.08v0l4.24,2.45,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,380.54l-2,1.17s-.06.06-.06.08l1.81,1.08,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,382l-2,1.17c-.06,0-.06.06-.06.08l1.8,1.08L119.1,383Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,364.09v.05l1.79,1,2.13-1.26-1.85-1.06-2,1.17A.09.09,0,0,0,110.86,364.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14,387.37l-1.84-1.07-4.81,2.77a.13.13,0,0,0,0,.07v0l1.8,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.67,362l-2,1.17s-.06.06-.06.07l2.19,1.31,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.49,363.62l-2,1.17s-.06.06-.06.08v0l13.88,8,2.13-1.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33,363.94l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.1.1,0,0,0,87.33,363.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.84,360.36l-2,1.17s-.06.05-.06.07l2.19,1.3,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,372l-2,1.17a.1.1,0,0,0,0,.08v0l2.18,1.26,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.68,375.27l-2,1.18a.08.08,0,0,0,0,.07v0l2.19,1.26,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,373.64l-2,1.18a.08.08,0,0,0,0,.07l2.19,1.3,2.12-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51,376.91l-2,1.17s-.06.06-.06.07v.05l2.7,1.55,2.13-1.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,378.42v0l1.79,1,2.13-1.26-1.85-1.07-2,1.18S123.45,378.39,123.45,378.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48,380.2v0l1.8,1,2.13-1.26L117.57,379l-2,1.17A.1.1,0,0,0,115.48,380.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,375.22l5,2.94L114,376.9,109,374l-2,1.18A.06.06,0,0,0,106.87,375.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,383.31v.05l1.8,1,2.13-1.27L123,382.07l-2,1.18A.07.07,0,0,0,120.88,383.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.33,384.72v0l1.79,1,2.13-1.27-1.85-1.06-2,1.17S123.33,384.71,123.33,384.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,373.81l1.8,1.08,2.13-1.26-1.85-1.06-2,1.17A.1.1,0,0,0,104.43,373.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,381.72v0l1.8,1,2.12-1.26-1.84-1.07-2,1.17C123.65,381.67,123.65,381.7,123.65,381.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.21,366.76,94,367.84l2.12-1.26-1.84-1.06-2,1.17A.1.1,0,0,0,92.21,366.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,372.4l1.81,1.08,2.13-1.26-1.85-1.06-2,1.18S102,372.37,102,372.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,365.35v0l1.8,1,2.12-1.26-1.84-1.06-2,1.17A.1.1,0,0,0,89.77,365.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.66,368.17l1.8,1.08L98.59,368l-1.85-1.06-2,1.18A.07.07,0,0,0,94.66,368.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1,369.58v.05l1.8,1L101,369.4l-1.85-1.06-2,1.17A.09.09,0,0,0,97.1,369.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,371V371l1.8,1,2.12-1.26-1.84-1.06-2,1.17A.1.1,0,0,0,99.54,371Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.81,367.53l1.8,1.08,2.13-1.26-1.85-1.07-2,1.17A.08.08,0,0,0,116.81,367.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.77,386.14v0l1.79,1L129.7,386l-1.85-1.07-2,1.18S125.77,386.11,125.77,386.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69,370.35l1.81,1.08,2.12-1.26-1.84-1.07-2,1.17S121.69,370.33,121.69,370.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12,373.48l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.08.08,0,0,0,127.12,373.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,372.07l1.8,1.08,2.13-1.26-1.85-1.07-2,1.18A.07.07,0,0,0,124.68,372.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,366.12l1.81,1.08,2.13-1.26-1.85-1.07-2,1.17S114.36,366.1,114.36,366.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.25,368.94v0l1.79,1,2.13-1.26-1.85-1.07-2,1.17S119.25,368.92,119.25,368.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56,374.89l1.81,1.08,2.12-1.26-1.85-1.07-2,1.18C129.57,374.84,129.56,374.87,129.56,374.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.55,380.42l1.81,1.08,1.11-.69-1.85-1.06-1,.6S140.55,380.39,140.55,380.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,382.76l1.81,1.08,2.13-1.26-1.85-1.06-2,1.17C136.5,382.72,136.49,382.75,136.49,382.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,376.19v0l1.79,1,1.11-.69-1.85-1.06-1,.59A.08.08,0,0,0,133.23,376.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.67,377.6v0l1.79,1,1.11-.69-1.84-1.06-1,.6A.1.1,0,0,0,135.67,377.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,379l1.81,1.08,1.11-.69-1.85-1.06-1,.6S138.11,379,138.11,379Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.21,381.86a4.77,4.77,0,0,0,.13,2.17,4.86,4.86,0,0,0,1.75,2.11,8.62,8.62,0,0,1,1.46,1.77,7.5,7.5,0,0,0,1.52,1.9,3.06,3.06,0,0,0,2.46.18c.64-.27.86-.52.82-1.55s-3.16-1.38-3.16-1.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,385.37c.26.1.33.61.37,1.62,0,.76.35,1.88-.7,2.36a2.57,2.57,0,0,1-2.78-.59,34,34,0,0,0-2.22-2.78c-.88-1-1.81-1.27-2.2-3.18-.25-1.22-.05-1.72.77-2.07,1.13-.49,2.91,1.09,3.79,1.34S447.68,385.27,448,385.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,382.07l-.15-.06a3,3,0,0,0-2.45,1.61c-.15.33.32.59.59.33a3.12,3.12,0,0,1,2.45-1.59A1.26,1.26,0,0,0,445,382.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.71,382.64a2.91,2.91,0,0,0-2.27,1.59c-.15.34.31.6.59.34a3,3,0,0,1,2-1.53C446,382.9,445.83,382.76,445.71,382.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.94,384.21s.09-2.26,3.15-2.58l.17.1a2.68,2.68,0,0,0-1.5-1.16,2.1,2.1,0,0,0-2.36.68C439.87,381.94,440.41,383.77,440.94,384.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,383.74v1.94a3,3,0,0,1-3.13.08c-.06-.12-.22-2-.22-2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.2,396.36c-.18.86.13,1.31,1.24,1.94a6.14,6.14,0,0,0,4.66.33c1.82-.53,2.69-1.33,3.45-1.52s2.63-.2,3.38-.42.73-.6.73-1.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.93,390.85s.35,1.08.54,2a5.51,5.51,0,0,1,.11,2.56c-.26.57-1.29.93-2.87.92a9.33,9.33,0,0,0-3.73,1.3,5.7,5.7,0,0,1-3.55.49c-1.42-.16-2.88-1-3.11-1.57s-.28-1,3-2.44c0,0,3.86-1.42,5.47-3.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53,397.87s-.29-2.86-2.61-3.67c-2.1-.74-3.93.81-3.72,2.16C424.33,397.27,426.89,399.34,430.53,397.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.51,393.66a2.73,2.73,0,0,1,1.59.7c.66.57.68.94.68.94a.35.35,0,0,0,.61-.29,2.18,2.18,0,0,0-2.05-1.73A.78.78,0,0,0,428.51,393.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,393a2.42,2.42,0,0,1,1.6.64c.67.56.67,1,.67,1a.36.36,0,0,0,.61-.29,2.19,2.19,0,0,0-2.05-1.74A.77.77,0,0,0,429.84,393Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,392.27a2.37,2.37,0,0,1,1.64.53c.7.51.74,1,.74,1,.16.22.65.06.58-.34a2.18,2.18,0,0,0-2.17-1.59A.77.77,0,0,0,431.16,392.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.93,389.51s0,.92,0,1.44-.62,1.31-2.23,1.26c-1.13,0-1.91-.35-1.87-1.28v-1.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.66,333.47c.34-12.67-.67-15.71-4.05-18l-1.3,7.34s1.53,8.65,1.37,11.54a40,40,0,0,1-1,7.74,1.57,1.57,0,0,1-.67.87,9.2,9.2,0,0,0-1.86,1.76c-.5.53-.93.67-.87.83a.84.84,0,0,0,1.07.38,5.63,5.63,0,0,0,1.22-.66,7.73,7.73,0,0,1-1.25,2.15c-1.2,1.47-1.26,2.38,1.18,2.4,1.52,0,2.74-.92,3.88-4.28a27.24,27.24,0,0,0,1.07-3.77A67.67,67.67,0,0,0,451.66,333.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.12,338a26.24,26.24,0,0,1-.66,3.74,5.77,5.77,0,0,1-3.52-.7l.45-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.43,314.76c1.82-.19,4,2.4,4.82,5.43s1,13.49-.13,17.81a5.3,5.3,0,0,1-3.73-.45,46.47,46.47,0,0,0-.31-7.38c-.47-2.41-1.6-8.13-1.35-9S446.43,314.76,446.43,314.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,368.11c-.15-3.76-.55-3.84-1.16-6.79.31-3.58.6-6.6.72-10.49.14-4.19,0-9.24,0-13.7-4.59-.31-16.08-4.11-17.52,3.11-.42,5.83.16,17.37.23,25.32s0,15.77.49,24.3a5.17,5.17,0,0,0,4.45-.33,146.14,146.14,0,0,0,2.52-15.15c.45-4-.2-4.33,0-7.5s.5-6.63.75-9.74.56-5.7.7-8.72a2.16,2.16,0,0,0,.37-.19c.24,3.69.33,6.87.58,10.65s.56,6.62,1,10.94c.37,4,.53,9.27,1.28,14.09,1.09.52,2.69,1,3.73.12C449.05,379.67,450.16,371.87,450,368.11Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450,368.11c-.15-3.76-.55-3.84-1.16-6.79.31-3.58.6-6.6.72-10.49.14-4.19,0-9.24,0-13.7-4.59-.31-16.08-4.11-17.52,3.11-.42,5.83.16,17.37.23,25.32s0,15.77.49,24.3a5.17,5.17,0,0,0,4.45-.33,146.14,146.14,0,0,0,2.52-15.15c.45-4-.2-4.33,0-7.5s.5-6.63.75-9.74.56-5.7.7-8.72a2.16,2.16,0,0,0,.37-.19c.24,3.69.33,6.87.58,10.65s.56,6.62,1,10.94c.37,4,.53,9.27,1.28,14.09,1.09.52,2.69,1,3.73.12C449.05,379.67,450.16,371.87,450,368.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M441.16,348.43a34.46,34.46,0,0,0,6.39-4,18.13,18.13,0,0,1-4.58,4.2c0,1-.86,8.95-.87,8.8-.23-1.78-.29-6.3-.58-9C441.4,348.38,441.28,348.44,441.16,348.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M449,317.43c-.52-1.57-2.5-3.27-4.48-2.9a58.56,58.56,0,0,0-8.69,2.17c-1.82.65-3.48,2.22-3.63,8.2,0,0-.61,13.93-.62,16.62a22,22,0,0,0,11.93,1.18c5.46-1.19,6.12-3.46,6.12-3.46s.07-10-.09-14.34C449.4,321.22,449.35,318.5,449,317.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.54 312.48 438.13 318.06 443.13 318.07 442.55 311.75 437.54 312.48",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.36,316.52c.36-.76.64-1.77,1.34-1.9a9.39,9.39,0,0,0,3.67-.14,3.15,3.15,0,0,0,1.54-1.08,1.69,1.69,0,0,1,1.8.33c.73.77,2.91,2.06,3.48,4.34s1,6.49-1.59,7.3c-3.86,1.19-6.6-.62-7.52-3.81C438.07,318.06,438.35,317.15,436.36,316.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.37,316.81c.63.86,1.3,4.62,2.8,6.09s4.74,1.11,5.33-.38a2.41,2.41,0,0,1-2.4,2.13,4.68,4.68,0,0,1-4.88-3.63C439.65,318.79,439.73,317.82,439.37,316.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,306s-1.27,2-1.11,2.21,1.12.35,1.12.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,300.4c-2.64.62-3.38,1.8-3.53,6-.16,4.4.32,5.78.91,6.36.4.39,2.57.41,3.65.08,1.36-.4,4.43-1.57,5.83-3.82,1.65-2.64,2-6.17.16-7.58C441.44,299.48,438.1,300.15,437,300.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.16,302.36a3.26,3.26,0,0,0,1.76.34c-.12,0-.08.5-.06.56a.92.92,0,0,0,.32.52,1,1,0,0,0,1.19.21c-.36.29-.09,1.19,0,1.55s.21.9.7,1.1c0,0,.38-1.64,1.76-1.46s1.61,1.93.76,3-1.66.7-1.66.7a7.2,7.2,0,0,0,1.15,3.62,6.23,6.23,0,0,0,7.23-3.94c1.58-3.75,1.62-7.09-.77-8a3.22,3.22,0,0,0-1.6-3.42,3.14,3.14,0,0,0-3.25,0c-.07,0-.41-.63-.44-.68a2.29,2.29,0,0,0-.89-.71,3.51,3.51,0,0,0-3.26.35,2.26,2.26,0,0,0-.93,1.52,4.32,4.32,0,0,0-2.68.63,2.45,2.45,0,0,0-.49,3.06A2.85,2.85,0,0,0,433.16,302.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.63,301.11l1.56-1a.92.92,0,1,0-1.56,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.87,327.05c.85.38,10.91,7.82,12.48,6.95S436,323.73,436,323.73a6.51,6.51,0,0,0,0-7.05,5.46,5.46,0,0,0-4.59,2.4c-1.44,2-6.6,8.74-6.6,8.74-1.44-.72-6.59-2.68-7.75-3.34a3.78,3.78,0,0,1-.9-.56c-.57-.56-.48-1.92-.47-2.66,0-.35,0-.69,0-1s.13-1.46-.63-1.13a1.06,1.06,0,0,0-.36.31,1.61,1.61,0,0,0-.27.52c-.15.44-.1.93-.23,1.39a.46.46,0,0,1-.1.18.38.38,0,0,1-.24.07c-1.1,0-2.15-1.59-2.66-2.41a2.25,2.25,0,0,0-.84-1,1.5,1.5,0,0,0-1.73.66,3.52,3.52,0,0,0-.55,2.45,4.88,4.88,0,0,0,1.45,3.06A14.78,14.78,0,0,0,413.87,327.05Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.18,326.29l-2.52-1.05a4.18,4.18,0,0,0-2,3.66l2.44,1.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.36,316.52a6,6,0,0,0-3.89,1.05c-1.44,1.26-7.77,9.91-7.77,9.91l-3.52-1.19a4.92,4.92,0,0,0-2.07,4.23s2.48,1.84,3.83,2.63a8,8,0,0,0,3.29,1.26c.59,0,9.49-9.74,9.49-9.74a7.78,7.78,0,0,0,1.61-4.54A8.8,8.8,0,0,0,436.36,316.52Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.45,318c-2.21.43-3.22,1.19-4.48,4.26s-4,10.48-4,12.59c0,1.62,5.58,9.14,5.33,9-.08,0,3.17-3.8,3.17-3.8l-3.37-5.33,2.67-5.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.37,383.8a4.72,4.72,0,0,1-.13,2.16,4.83,4.83,0,0,1-1.75,2.1,8.48,8.48,0,0,0-1.44,1.76,7.65,7.65,0,0,1-1.52,1.89,3,3,0,0,1-2.44.17c-.64-.26-.86-.51-.82-1.53S62.42,389,62.42,389Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,387.3c-.27.1-.34.6-.38,1.6,0,.76-.35,1.87.7,2.35a2.55,2.55,0,0,0,2.76-.58A33.65,33.65,0,0,1,65,387.9c.88-.95,1.79-1.27,2.18-3.15.26-1.22.06-1.72-.76-2.07-1.12-.48-2.89,1.09-3.77,1.33S59.94,387.2,59.68,387.3Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,387.3c-.27.1-.34.6-.38,1.6,0,.76-.35,1.87.7,2.35a2.55,2.55,0,0,0,2.76-.58A33.65,33.65,0,0,1,65,387.9c.88-.95,1.79-1.27,2.18-3.15.26-1.22.06-1.72-.76-2.07-1.12-.48-2.89,1.09-3.77,1.33S59.94,387.2,59.68,387.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,384l.15-.05a2.88,2.88,0,0,1,2.43,1.6c.15.33-.31.58-.58.33a3.1,3.1,0,0,0-2.43-1.59A1.29,1.29,0,0,1,62.62,384Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,384.58a2.89,2.89,0,0,1,2.26,1.59c.15.33-.32.58-.59.33a3,3,0,0,0-2-1.52C61.66,384.84,61.78,384.7,61.9,384.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.64,386.14s-.09-2.24-3.13-2.56l-.17.1a2.6,2.6,0,0,1,1.49-1.15,2.06,2.06,0,0,1,2.34.67C67.7,383.88,67.16,385.71,66.64,386.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49,399.32c.17.85-.14,1.29-1.23,1.93a6.12,6.12,0,0,1-4.63.32c-1.81-.52-2.68-1.32-3.43-1.5s-2.62-.21-3.36-.43-.73-.59-.73-1.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,393.84s-.35,1.07-.54,2a5.33,5.33,0,0,0-.11,2.55c.26.56,1.28.92,2.85.91a9.18,9.18,0,0,1,3.7,1.29,5.67,5.67,0,0,0,3.54.49c1.4-.16,2.86-1,3.08-1.56s.29-1-3-2.42c0,0-3.83-1.42-5.43-3.19Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.84,393.84s-.35,1.07-.54,2a5.33,5.33,0,0,0-.11,2.55c.26.56,1.28.92,2.85.91a9.18,9.18,0,0,1,3.7,1.29,5.67,5.67,0,0,0,3.54.49c1.4-.16,2.86-1,3.08-1.56s.29-1-3-2.42c0,0-3.83-1.42-5.43-3.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,400.82s.28-2.84,2.59-3.65c2.08-.74,3.9.81,3.7,2.15C81.35,400.23,78.81,402.28,75.2,400.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,396.63a2.68,2.68,0,0,0-1.57.7c-.67.56-.69.94-.69.94a.35.35,0,0,1-.6-.29,2.18,2.18,0,0,1,2-1.73A.76.76,0,0,1,77.2,396.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,396a2.35,2.35,0,0,0-1.59.63c-.66.56-.67,1-.67,1a.35.35,0,0,1-.6-.28,2.18,2.18,0,0,1,2-1.73A.76.76,0,0,1,75.88,396Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.57,395.26a2.36,2.36,0,0,0-1.63.52c-.7.51-.73,1-.73,1a.35.35,0,0,1-.58-.33,2.16,2.16,0,0,1,2.15-1.58A.77.77,0,0,1,74.57,395.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,385.67v1.93a3,3,0,0,0,3.11.08c.05-.12.21-2,.21-2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,392.51v1.43c0,.53.61,1.31,2.21,1.25,1.12,0,1.9-.34,1.86-1.27v-1.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,369.33a16,16,0,0,1,.94-5.84s-.6-5-1-11.16c-.56-9,1.46-11.93,3.31-16.13,0,0,14.56-1,14.77,5.6.28,8.88.1,24.82-.11,27.7s-.22.22-.92,6c-.55,4.61-1.69,17-1.69,17a4.32,4.32,0,0,1-4.07-.08S67.55,377.29,67.69,374a37.2,37.2,0,0,1,.39-5.09S66.24,355.75,66,353.64c0,0-.26,3.78-.48,6.66s-.19,5.2-.8,11.15c-.48,4.67-1.63,14.75-1.63,14.75a3.88,3.88,0,0,1-3.43-.25S57.51,372.62,57.6,369.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,353.64l-.3-3.18a11.92,11.92,0,0,1-4.8-1.82A6.52,6.52,0,0,0,64.69,351l.63,3.1.16,6.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.51 315.91 69.77 321.99 64.43 321.5 65.04 314.75 70.51 315.91",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,321c.59-1.6,1.94-3.28,4-2.9l1.51.28c.05,1.4,2.69,2.13,5.32,1.28.79.22,1.52.46,2.17.69,1.89.67,3.53,4.26,3.57,9.49s-.89,13.55-.89,13.55-3.42,4.81-10.58,2.48c-5.22-1.7-6.1-3.17-6.1-3.17s1.82-4.34,3.09-7.91C58.45,327.22,58.34,323.34,59.21,321Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,321c.59-1.6,1.94-3.28,4-2.9l1.51.28c.05,1.4,2.69,2.13,5.32,1.28.79.22,1.52.46,2.17.69,1.89.67,3.53,4.26,3.57,9.49S76,350.7,76,350.7s-1.52-1.05-2.64-5.93a8.16,8.16,0,0,1-10.43,6.93c-5.22-1.69-5.4-3.95-5.73-6.45.26-2,2.11-6.67,4.13-10.49C58.45,327.22,58.34,323.34,59.21,321Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,308.18a4.68,4.68,0,0,0-.41-4.52c-1.79-2.82-5.25-3.3-9.35-2.2a7.25,7.25,0,0,0-5.13,6.6c-.2,3,8.19,5.23,8,7.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.67,309.32s1.14,1.83,1,2a2.76,2.76,0,0,1-.92.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.44,310.36a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,74.44,310.36Zm0-2.6a1.21,1.21,0,1,0,1.21,1.2A1.2,1.2,0,0,0,74.44,307.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2,303.54c1.13.63,3.1,1.78,3.49,6s-.6,5.86-1.21,6.41c-.41.38-2.48.46-3.56.1a11.28,11.28,0,0,1-5.54-4.27c-1.54-2.69-1.78-6.23.12-7.56A7,7,0,0,1,71.2,303.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,315.35l-.2.88a6.35,6.35,0,0,0,2.82-.12,4.84,4.84,0,0,1-1-.12A6.79,6.79,0,0,1,70.67,315.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14,308.69a4.33,4.33,0,0,0,2.78-3.49c.42-2.78-3-4-3-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.53,303.73s.9,4-.37,6.49c0,0-.67-1.57-2-1.16a1.81,1.81,0,0,0-.39,3.15,1.36,1.36,0,0,0,1.75,0,9,9,0,0,1-2,3.2s-3.52,2.06-7-1.83c-3.13-3.54-2.23-9.84,2.25-11.16A8.28,8.28,0,0,1,71.53,303.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,330c.77-.88.9-2.84,1.94-4.19s.84-2.7,1.49-2.1.17,2.81.17,2.81a13.19,13.19,0,0,1,1.3,3.38c.1,1.14-2.92,4-2.92,4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.17,326.32s1.23,1.71,6.75-.52c1.52-.62.49,2.66-1.38,4s-3.89,1.65-5.63,2.82C88.91,332.46,89.17,326.32,89.17,326.32Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,320.16c2.38.43,3.58.68,4.9,3.8,1.56,3.7,4.82,10.62,4.82,10.62L85.74,330s.62-.87,1.78,1,.64,2.44.64,2.44-5,6.66-5.88,7.5-2.41.19-3.39-1.14-6.21-9.72-6.21-9.72S69.51,323.51,71.74,320.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,306c-1,2.43-1.83,12.69-.08,16s6.71,5.51,9.9,4.36c2-.7,4.6-2.36,3-4.75A8.23,8.23,0,0,0,71.29,320a3.94,3.94,0,0,1-1.09-1.59c-.71-1.55.25-6.06.31-6.21s-.52,1.93-4.15.89C64.7,312.66,60,306,60,306Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.44b4c9cc4f8672bcd58081fe04444ed7.svg";
export { ForwardRef as ReactComponent };